<template>
  <div class="lucky pk-lucky-page">
    <div class="pk-lucky-content">
      <navheader
        v-if="false"
        :showNav="showNav"
        :yidongmenu="yidongmenu"
        :openHongbao="openHongbao"
      ></navheader>
      <div class="lucky-warp">
        <div class="top">
          <div class="left">盲盒对战</div>
          <div class="right">
            <span class="right-span right-span1" @click="goLuckyRule"
              >怎么玩?</span
            >
            <span class="right-span right-span1" @click="goLuckyHistory"
              >我的战斗历史</span
            >
            <span class="right-span right-span1" @click="goLuckyHistory"
              >战斗历史</span
            >
            <div class="pk-battle-sort">
              <span class="active">按日期排序</span>
              <span>按价格排序</span>
            </div>
            <span class="right-span right-span2" @click="openDrawer"
              >创建战斗</span
            >
          </div>
        </div>

        <div class="luc-list luc-list1" v-if="boxList.length">
          <ul :style="{ width: 100 * boxList.length + 'px' }">
            <li v-for="(item, index) in boxList" :key="index">
              <div class="list-warp" @click="getBot(item.name, item.id)">
                <div class="list-img">
                  <img :src="battleCaseImage(item.img_main, index)" @error="useCaseFallback($event, index)" />
                </div>
                <div class="list-money">
                  <img src="../assets/img/money.png" />
                  <span>{{ item.price }}</span>
                </div>
                <div class="list-name">{{ item.name }}</div>
              </div>
            </li>
          </ul>
        </div>

        <div class="luc-list luc-list2" v-if="boxList.length">
          <el-carousel
            indicator-position="outside"
            height="150px"
            :autoplay="false"
          >
            <el-carousel-item v-for="(item, index) in boxList2" :key="index">
              <ul>
                <li v-for="(item1, index1) in item" :key="index1">
                  <div class="list-warp" @click="getBot(item1.name, item1.id)">
                    <div class="list-img">
                      <img
                        :src="battleCaseImage(item1.img_main, index * 10 + index1)"
                        @error="useCaseFallback($event, index * 10 + index1)"
                      />
                    </div>
                    <div class="list-money">
                      <img src="../assets/img/money.png" />
                      <span>{{ item1.price }}</span>
                    </div>
                    <div class="list-name">{{ item1.name }}</div>
                  </div>
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="pk-battle-empty" v-if="!boxList.length">暂无可用于创建对战的箱子。</div>

        <div class="clear"></div>

        <div class="hint">
          <span
            >每局活动，玩家连续打开相同盲盒，奖品总价最高的玩家可获得全部奖品</span
          >
          <span>{{ awaitRoom }} 个房间等待您加入</span>
        </div>

        <div
          v-if="is_mobile"
          @click="topRank = true"
          style="
            color: #000000;
            text-align: center;
            margin: 30px auto;
            padding: 10px 20px;
            font-size: 16px;
            border-radius: 5px;
            cursor: pointer;
            font-weight: bold;
            background-color: #ffc400;
            width: max-content;
          "
        >
          查看排行榜
        </div>
        <el-drawer
          v-if="is_mobile"
          title="对战排行榜"
          size="80%"
          :append-to-body="true"
          :visible.sync="topRank"
          direction="ltr"
        >
          <div class="ranking">
            <div class="rank-top">
              <div class="one">对战之神</div>
              <div class="two">
                <div class="winner-warp">
                  <img
                    class="winner"
                    :class="star.img ? 'img-block' : 'img-none'"
                    src="../assets/img/winner-bg.svg"
                    alt=""
                  />
                  <img class="winner1" :src="star.img" @error="useAvatarFallback" />
                </div>
                <span>Lv1</span>
              </div>
              <div class="three">
                <span>{{ star.name }}</span>
              </div>
              <div class="four">{{ star.total_consume }}</div>
            </div>
            <div class="rank-bot">
              <div class="title">排行榜</div>
              <div class="ranking-list">
                <ul>
                  <li v-for="(item, index) in list1" :key="index">
                    <div class="ripple" @click="touchstart">
                      <div class="list-left">
                        <div class="list-left1">
                          <img :src="item.img" @error="useAvatarFallback" /><span>Lv1</span>
                        </div>
                        <div class="list-left2">
                          <span>{{ item.name }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="list-right">{{ item.total_consume }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-drawer>

        <div class="room">
          <div class="ranking">
            <div class="rank-top">
              <div class="one">对战之神</div>
              <div class="two">
                <div class="winner-warp">
                  <img
                    class="winner"
                    :class="star.img ? 'img-block' : 'img-none'"
                    src="../assets/img/winner-bg.svg"
                    alt=""
                  />
                  <img class="winner1" :src="star.img" @error="useAvatarFallback" />
                </div>
                <span>Lv1</span>
              </div>
              <div class="three">
                <span>{{ star.name }}</span>
              </div>
              <div class="four">{{ star.total_consume }}</div>
            </div>
            <div class="rank-bot">
              <div class="title">排行榜</div>
              <div class="ranking-list">
                <ul>
                  <li v-for="(item, index) in list1" :key="index">
                    <div class="ripple" @click="touchstart">
                      <div class="list-left">
                        <div class="list-left1">
                          <img :src="item.img" @error="useAvatarFallback" /><span>Lv1</span>
                        </div>
                        <div class="list-left2">
                          <span>{{ item.name }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="list-right">{{ item.total_consume }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="clear"></div>
          <div class="pk-pvp-short-title">
            <span>创建战斗</span>
          </div>
          <div class="room-box">
            <ul class="room-box-ul">
              <li
                v-for="(item, index) in list"
                :key="index"
                @click="goLuckyRoom(item.id)"
                :class="[item.class, `bg_${item.status}`]"
              >
                <div
                  class="roombox-warp"
                  :class="{
                    two1: item.status == 1,
                    two3: item.status == 2,
                    two2: item.status == 3,
                  }"
                >
                  <div
                    :class="{
                      'one two1 ': item.status == 1,
                      'one two3': item.status == 2,
                      'one two2': item.status == 3,
                    }"
                  >
                    <div class="status-condiv">
                      <div
                        class="point"
                        :class="[`point_${item.status}`]"
                      ></div>
                      <span class="pk-player-label">玩家</span>
                      <span class="pk-player-value">{{ item.joined_count }}/{{ item.mode }}</span>
                      <span class="pk-player-count">{{ item.joined_count }}/{{ item.mode }}</span>
                      <div :class="[`text_${item.status}`]">
                        <span class="pk-player-count">{{ item.joined_count }}/{{ item.mode }}</span>
                        {{ ["等待中", "进行中", "已结束"][item.status - 1] }}
                      </div>
                    </div>
                    <img
                      class="status-img"
                      src="@/assets/new/dzwj.png"
                      alt=""
                      srcset=""
                    />
                    <span class="pk-rounds-count">{{ item.boxInfo.length }} 回合</span>
                    <span class="span3">{{ item.boxInfo.length }}回合</span>
                  </div>
                  <div
                    :class="{
                      'two two1 ': item.status == 1,
                      'two two3': item.status == 2,
                      'two two2': item.status == 3,
                    }"
                  >
                    <div class="two-bot">
                      <div class="room-peo" v-if="item.mode == 2">
                        <div
                          class="pk-warp"
                          v-for="(item2, index2) in item.player_info"
                          :key="index2"
                        >
                          <span
                            class="pk-tou"
                            :class="
                              item2.class == 'pk-false' ? 'pk-tou-false' : ''
                            "
                          >
                            <img
                              style="object-fit: cover"
                              :class="item2.class"
                              :src="item2.img"
                              alt=""
                              @error="useAvatarFallback"
                            />
                            <!-- 头像框 -->
                            <img
                              v-if="item2.image"
                              style="object-fit: cover"
                              :class="[item2.class, 'image-border']"
                              :src="item2.image"
                              alt=""
                              @error="useAvatarFallback"
                            />
                          </span>
                          <img
                            class="vs"
                            v-if="index2 + 1 != item.player_info.length"
                            src="@/assets/new/vs.png"
                            alt=""
                            srcset=""
                          />
                        </div>
                      </div>

                      <div class="room-peo" v-if="item.mode == 3">
                        <div
                          class="pk-warp"
                          v-for="(item3, index3) in [
                            ...item.play1,
                            ...item.play2,
                          ]"
                          :key="index3"
                        >
                          <span
                            class="pk-tou"
                            :class="
                              item3.class == 'pk-false' ? 'pk-tou-false' : ''
                            "
                          >
                            <img
                              :class="item3.class"
                              style="object-fit: cover"
                              :src="item3.img"
                              alt=""
                              @error="useAvatarFallback"
                            />
                            <!-- 头像框 -->
                            <img
                              v-if="item3.image"
                              style="object-fit: cover"
                              :class="[item3.class, 'image-border']"
                              :src="item3.image"
                              alt=""
                              @error="useAvatarFallback"
                            />
                          </span>
                          <img
                            class="vs"
                            v-if="
                              index3 + 1 !=
                              [...item.play1, ...item.play2].length
                            "
                            src="@/assets/new/vs.png"
                            alt=""
                            srcset=""
                          />
                        </div>
                      </div>

                      <div class="room-peo" v-if="item.mode == 4">
                        <div class="pk-warp">
                          <div
                            v-for="(item4, index4) in [
                              ...item.play1,
                              ...item.play2,
                            ]"
                            :key="index4"
                            class="vs-info"
                          >
                            <span
                              class="pk-tou"
                              :class="
                                item4.class == 'pk-false' ? 'pk-tou-false' : ''
                              "
                            >
                              <img
                                :class="item4.class"
                                style="object-fit: cover"
                                :src="item4.img"
                                alt=""
                                @error="useAvatarFallback"
                              />
                              <!-- 头像框 -->
                              <img
                                v-if="item4.image"
                                style="object-fit: cover"
                                :class="[item4.class, 'image-border']"
                                :src="item4.image"
                                alt=""
                                @error="useAvatarFallback"
                              />
                            </span>
                            <img
                              class="vs"
                              v-if="
                                index4 + 1 !=
                                [...item.play1, ...item.play2].length
                              "
                              src="@/assets/new/vs.png"
                              alt=""
                              srcset=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="pk-battle-info-panel">
                    <span class="pk-battle-player">玩家 {{ item.joined_count }}/{{ item.mode }}</span>
                    <span class="pk-battle-state">{{ ["等待中", "进行中", "已结束"][item.status - 1] }}</span>
                    <span class="pk-battle-rounds">{{ item.boxInfo.length }} 回合</span>
                  </div>

                  <div class="card-footer">
                    <div
                      :class="{
                        'three two1 ': item.status == 1,
                        'three two3': item.status == 2,
                        'three two2': item.status == 3,
                      }"
                    >
                      <div
                        class="box-detail"
                        v-for="(item1, index1) in caculateBoxNum(item.boxInfo)"
                        :key="index1"
                      >
                        <img
                          :src="battleCaseImage(item1.current.img_main, index * 6 + index1)"
                          alt=""
                          @error="useCaseFallback($event, index1)"
                        />
                        <div class="box-num">{{ item1.num }}</div>
                      </div>
                    </div>
                    <div class="two-top">
                      <img src="../assets/new/money.png" alt="" />
                      <span>{{ item.price }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <div class="pk-battle-empty pk-battle-empty-rooms" v-if="!list.length">暂无进行中或等待中的真实对战房间。</div>

            <div class="clear"></div>
            <div class="more-btn">
              <span @click="moveList()">查看更多</span>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>

      <!--  右侧创建房间盒子 -->
      <el-drawer
        :visible.sync="drawer"
        direction="rtl"
        size="620px"
        :append-to-body="true"
        :with-header="false"
        class="sty"
      >
        <div class="sty-warp">
          <div class="sty-one">
            <div class="sty-one-hint">设置房间模式</div>
            <div class="sty-one-pattern">
              <span
                v-for="(item, index) in patternList"
                :key="index"
                :class="item.state ? '' : 'span1'"
                @click="selectPattern(item.name)"
                >{{ item.name }}</span
              >
            </div>
          </div>
          <div class="sty-two">
            <div class="sty-two-hint1">单击选择盲盒</div>
            <div class="sty-two-hint2">你能选择最多6 件盲盒</div>
            <div class="sty-two-list">
              <ul>
                <li
                  v-for="(item, index) in boxList"
                  :key="index"
                  @click="addBox(index, item.price)"
                >
                  <div class="twolist-warp">
                    <div class="twolist-top">
                      <img :src="battleCaseImage(item.img_main, index)" @error="useCaseFallback($event, index)" />
                    </div>
                    <div class="twolist-bot">
                      <img src="../assets/img/money.png" />
                      <span>{{ item.price }}</span>
                    </div>

                    <div :class="item.num > 0 ? 'twolist-num' : 'twolist-num1'">
                      x{{ item.num }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="sty-three">
            <div class="sty-three-hint">
              <span
                >已选择: <strong>{{ currentBoxNum }}</strong
                >/6</span
              >
              <span
                >价值: <strong>{{ totalPrice }}</strong></span
              >
            </div>
            <div class="sty-three-list">
              <ul>
                <li
                  v-for="(item, index) in selectList"
                  :key="index"
                  @click="remBox(item.name, item.price)"
                >
                  <div class="threelist-warp">
                    <div v-if="item.state">
                      <div class="threelist-img">
                      <img :src="battleCaseImage(item.img_main, index)" @error="useCaseFallback($event, index)" />
                      </div>
                      <div class="threelist-name">
                        <img src="../assets/img/money.png" />
                        <span>{{ item.price }}</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="sty-three-btn1">
              <el-button
                :disabled="loading2"
                class="sty-three-btn"
                @click="createRoom()"
              >
                <i v-if="loading2" class="el-icon-loading"></i>创建活动
              </el-button>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
    <el-drawer
      title="我是标题"
      :visible.sync="drawerBot"
      :append-to-body="true"
      :with-header="false"
      direction="btt"
      class="box-bot"
    >
      <div class="box-img">
        <div class="box-img-title">
          <span class="span1">{{ drawerName }}</span> <span>包含以下奖励</span>
        </div>
        <div class="box-img-list">
          <ul>
            <li v-for="(item, index) in drawerList" :key="index">
              <div class="box-img1">
                <img :src="item.img" />
              </div>
              <div class="box-img-name" :title="item.name">
                {{ item.name }}
                <div class="list-pirce">
                  <div class="pirce-left">
                    <img src="../assets/img/money.png" />
                    <span>{{ item.price }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-drawer>
    <myhomebot v-if="false"></myhomebot>
  </div>
</template>

<script>
import myhomebot from "@/components/my_homebot.vue";
import myinform from "@/components/my_inform.vue";
import SockJS from "sockjs-client";
import navheader from "@/components/navheader.vue";
import Stomp from "stompjs";
import Utils from "./../assets/js/util.js";

import { battle } from "@/api/socket.js";

export default {
  components: { myhomebot, myinform, navheader },
  props: ["yidongmenu", "showNav", "openHongbao"],
  data() {
    return {
      loading2: false,
      drawerList: [],
      drawerName: "",
      drawerBot: false,
      loading1: false,
      sockBattleData: "",
      loading: true,
      websock: "",
      battleRefreshTimer: null,
      timer: "",
      awaitRoom: 0,
      currentBoxNum: 0,
      currentBoxTotalPrice: 0,
      totalPrice: 0,
      mode: "2",
      page: 1,
      pageSize: 20,
      boxInfo: [],
      list: [],
      star: {},
      list1: [],
      boxList: [],
      boxList2: [],
      caseFallbackImages: [
        require("../assets/hotpizza/hp-case-purple-transparent.png"),
        require("../assets/hotpizza/hp-case-crystal.png"),
        require("../assets/hotpizza/hp-case-orange.png"),
        require("../assets/hotpizza/hp-case-green.png"),
        require("../assets/hotpizza/hp-case-blue.png"),
        require("../assets/hotpizza/hp-case-ice.png"),
      ],
      selectList: [
        { state: false, name: "" },
        { state: false, name: "" },
        { state: false, name: "" },
        { state: false, name: "" },
        { state: false, name: "" },
        { state: false, name: "" },
      ],
      drawer: false, //右侧导航状态
      patternList: [
        //选择模式
        { name: "双人模式", state: true, val: 2 },
        { name: "三人模式", state: false, val: 3 },
        { name: "四人模式", state: false, val: 4 },
      ],
      peopleObj: {
        img: require("../assets/img/jiapeople.png"),
        class: "pk-false",
        border: "1px dashed #e9b10e",
      },
      img: require("../assets/img/15mdpi.png"),

      is_mobile: false,
      topRank: false,
    };
  },
  watch: {
    currentBoxTotalPrice(val) {
      let _this = this;
      _this.totalPrice = val.toFixed(2);
    },
  },

  methods: {
    isMobile() {
      let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      return flag;
    },
    useCaseFallback(event, index) {
      const fallback = this.caseFallbackImages[index % this.caseFallbackImages.length];
      if (event.target.src != fallback) {
        event.target.src = fallback;
      }
    },
    battleCaseImage(url, index) {
      const image = String(url || "")
        .replace("http://csgoapi.akaifa998.icu/http://", "http://")
        .replace("http://csgoapi.akaifa998.icu/https://", "https://");
      if (image.indexOf("standoffi.oss-cn-hongkong.aliyuncs.com") !== -1) {
        return this.caseFallbackImages[index % this.caseFallbackImages.length];
      }
      return image || this.caseFallbackImages[index % this.caseFallbackImages.length];
    },
    normalizeAvatarUrl(url) {
      if (url && url.indexOf("http://csgoapi.akaifa998.icu/http") == 0) {
        return url.replace("http://csgoapi.akaifa998.icu/", "");
      }
      return url;
    },
    useAvatarFallback(event) {
      if (event.target.src != this.peopleObj.img) {
        event.target.src = this.peopleObj.img;
      }
    },
    //计算分类 根据盒子计算同一类的数量
    caculateBoxNum(box) {
      const result = box.reduce((total, current) => {
        if (total[current.box_id]) {
          total[current.box_id].num += 1;
        } else {
          total[current.box_id] = {
            num: 1,
            current,
          };
        }
        return total;
      }, {});
      return Object.keys(result).map((box_id) => result[box_id]);
    },
    getBot(name, id) {
      this.drawerBot = true;
      this.drawerName = name;
      let param = {
        box_id: id,
      };
      this.$axios
        .post("/index/Box/boxInfo", this.$qs.stringify(param))
        .then((res) => {
          let data = res.data;
          if (data.status == 1) {
            this.drawerList = data.data.box_skins;
          }
        });
    },
    //对战排行
    rankList() {
      this.$axios.post("/index/Battle/ranking").then((res) => {
        var data = res.data;
        if (data.status == "1") {
          this.list1 = data.data.rank;
          this.star = data.data.star;
          for (let i = 0; i < this.list1.length; i++) {
            this.list1[i].img = this.normalizeAvatarUrl(this.list1[i].img);
            this.list1[i].total_consume = this.list1[i].total_consume.toFixed(
              2
            );
          }
          if (this.star) {
            this.star.img = this.normalizeAvatarUrl(this.star.img);
            this.star.total_consume = this.star.total_consume.toFixed(2);
          }
        }
      });
    },

    //推送
    initWebSocket() {
      const wsuri = battle();
      if (!wsuri) {
        return;
      }
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },

    websocketonopen() {
      //let actions = { test: "12345" };
      //this.websocketsend(JSON.stringify(actions));
    },

    websocketonerror() {
      // Local deployment uses HTTP polling until a PizzaKing gateway is configured.
    },

    websocketonmessage(d) {
      // console.log("接收:",JSON.parse(d.data));
      // console.log(JSON.parse(d.data));
      this.sockBattleList(d.data);
    },

    websocketsend(Data) {
      if (this.websock.readyState === WebSocket.OPEN) {
        this.websock.send(Data);
      }
    },

    websocketclose(e) {
      // console.log("close:", e);
    },

    updateBattleList(item) {
      this.list.forEach((ele, index) => {
        if (ele.id == item.id) {
          this.list[index].class = "";
          this.$set(this.list, index, item);
          // console.log("更新：", this.list);
        }
      });
    },

    addBattleList(item) {
      if (this.list.length == 0) {
        this.list.push(item);
        return;
      }
      let insert = false;
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].status == 3 && this.list.length >= 12) {
          item.class = "replace-room";
          this.$set(this.list, i, item);
          insert = true;
          break;
        }
      }
      let e = this.list.filter((ele, index, arr) => {
        return ele.id == item.id;
      });
      if (!insert && e.length == 0) {
        this.list.push(item);
      }
    },

    sockBattleList(d) {
      let data = JSON.parse(d);
      console.log(data);

      if (data.info == undefined) {
        return;
      }
      if (data.state == "update") {
        this.updateBattleList(data.info);
      } else if (data.state == "add") {
        this.addBattleList(data.info);
      }

      let _this = this;
      this.awaitRoom = 0;
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].boxInfo = this.list[i].boxInfo;
        this.list[i].price = 0;
        var info = this.list[i].boxInfo;
        for (let j = 0; j < info.length; j++) {
          this.list[i].price += Number(info[j].price);
        }
        this.list[i].price = this.list[i].price.toFixed(2);
        if (this.list[i].status == "1") {
          this.awaitRoom = this.awaitRoom + 1;
        }
      }
      //几个人参与
      for (let i = 0; i < this.list.length; i++) {
        this.$set(this.list[i], "joined_count", this.list[i].player_info.length);
        let play = JSON.parse(JSON.stringify(this.list[i].player_info));
        let mode = this.list[i].mode;
        for (let j = 0; j < mode - this.list[i].player_info.length; j++) {
          play.push(this.peopleObj);
        }
        for (let x = 0; x < play.length; x++) {
          if (play[x].id) {
            play[x].class = "pk-true";
            play[x].img = this.normalizeAvatarUrl(play[x].img);
          }
        }
        this.list[i].player_info = play;

        if (mode == "3") {
          this.list[i].play1 = [];
          this.list[i].play2 = [];
          this.list[i].play1.push(play[0]);
          this.list[i].play2.push(play[1]);
          this.list[i].play2.push(play[2]);
        }
        if (mode == "4") {
          this.list[i].play1 = [];
          this.list[i].play2 = [];
          this.list[i].play1.push(play[0]);
          this.list[i].play1.push(play[1]);
          this.list[i].play2.push(play[2]);
          this.list[i].play2.push(play[3]);
        }
      }
      //排序
    },

    touchstart(event) {
      // console.log("touch");
      var style = document.createElement("style");
      style.innerHTML = `.ripple::after{top:${event.offsetY - 25}px;left:${
        event.offsetX - 180
      }px;}`;
      document.head.appendChild(style);
    },

    //查看更多
    moveList() {
      // console.log(this.pageSize);
      let _this = this;
      let param = {
        page: this.page,
        pageSize: this.pageSize + 12,
      };
      _this.$axios
        .post("/index/Battle/battleList", _this.$qs.stringify(param))
        .then((res) => {
          // console.log(res.data);
          var data = res.data;
          if (data.status == "1" && data.data != null) {
            this.pageSize = this.pageSize + 12;
            //let list = data.data.battleList;
            this.list = data.data.battleList;
            this.awaitRoom = 0;
            for (let i = 0; i < this.list.length; i++) {
              this.list[i].boxInfo = this.list[i].boxInfo;
              this.list[i].price = 0;
              var info = this.list[i].boxInfo;
              for (let j = 0; j < info.length; j++) {
                this.list[i].price += Number(info[j].price);
              }
              this.list[i].price = this.list[i].price.toFixed(2);
              if (this.list[i].status == "1") {
                this.awaitRoom = this.awaitRoom + 1;
              }
            }
            //几个人参与
            for (let i = 0; i < this.list.length; i++) {
              this.$set(this.list[i], "joined_count", this.list[i].player_info.length);
              let play = JSON.parse(JSON.stringify(this.list[i].player_info));
              let mode = this.list[i].mode;
              for (let j = 0; j < mode - this.list[i].player_info.length; j++) {
                play.push(this.peopleObj);
              }
              for (let x = 0; x < play.length; x++) {
                if (play[x].id) {
                  play[x].class = "pk-true";
                  play[x].img = this.normalizeAvatarUrl(play[x].img);
                }
              }
              this.list[i].player_info = play;

              if (mode == "3") {
                this.list[i].play1 = [];
                this.list[i].play2 = [];
                this.list[i].play1.push(play[0]);
                this.list[i].play2.push(play[1]);
                this.list[i].play2.push(play[2]);
              }
              if (mode == "4") {
                this.list[i].play1 = [];
                this.list[i].play2 = [];
                this.list[i].play1.push(play[0]);
                this.list[i].play1.push(play[1]);
                this.list[i].play2.push(play[2]);
                this.list[i].play2.push(play[3]);
              }
            }
          }
        });
    },
    //对战列表
    getList() {
      let _this = this;
      let param = {
        page: this.page,
        pageSize: this.pageSize,
      };
      _this.$axios
        .post("/index/Battle/battleList", _this.$qs.stringify(param))
        .then((res) => {
          // console.log(res.data);
          var data = res.data;
          if (data.status == "1" && data.data != null) {
            this.list = data.data.battleList;
            this.awaitRoom = 0;
            for (let i = 0; i < this.list.length; i++) {
              this.list[i].boxInfo = this.list[i].boxInfo;
              this.list[i].price = 0;
              var info = this.list[i].boxInfo;
              for (let j = 0; j < info.length; j++) {
                this.list[i].price += Number(info[j].price);
              }
              this.list[i].price = this.list[i].price.toFixed(2);
              if (this.list[i].status == "1") {
                this.awaitRoom = this.awaitRoom + 1;
              }
            }
            //几个人参与
            for (let i = 0; i < this.list.length; i++) {
              this.$set(this.list[i], "joined_count", this.list[i].player_info.length);
              let play = JSON.parse(JSON.stringify(this.list[i].player_info));
              let mode = this.list[i].mode;
              for (let j = 0; j < mode - this.list[i].player_info.length; j++) {
                play.push(this.peopleObj);
              }
              for (let x = 0; x < play.length; x++) {
                if (play[x].id) {
                  play[x].class = "pk-true";
                  play[x].img = this.normalizeAvatarUrl(play[x].img);
                }
              }
              this.list[i].player_info = play;

              if (mode == "3") {
                this.list[i].play1 = [];
                this.list[i].play2 = [];
                this.list[i].play1.push(play[0]);
                this.list[i].play2.push(play[1]);
                this.list[i].play2.push(play[2]);
              }
              if (mode == "4") {
                this.list[i].play1 = [];
                this.list[i].play2 = [];
                this.list[i].play1.push(play[0]);
                this.list[i].play1.push(play[1]);
                this.list[i].play2.push(play[2]);
                this.list[i].play2.push(play[3]);
              }
            }
            //排序
          }
        });
    },
    //盲盒选择列表
    getBattleBoxList() {
      let _this = this;
      _this.$axios.post("/index/Battle/battleBoxList").then((res) => {
        res.data.data.forEach((element) => {
          element.num = 0;
        });
        _this.boxList = res.data.data;
        _this.loading = true;

        let arr = [];
        for (let i = 0; i < this.boxList.length / 10; i++) {
          this.boxList2.push(arr);
        }
        for (let i = 0; i < this.boxList2.length; i++) {
          this.boxList2[i] = this.boxList.slice(i * 10, (i + 1) * 10);
        }
      });
    },
    //创建活动
    createRoom() {
      if (!this.$store.state.token) {
        this.$store.commit("getLogin", true);
        return;
      }

      let _this = this;
      _this.boxInfo = [];
      _this.selectList.forEach((e) => {
        if (e.state) {
          e.num = 1;
          _this.boxInfo.push(e);
        }
      });
      if (_this.boxInfo.length == 0) {
        _this.$message({
          message: "请选择箱子",
          type: "warning",
        });
        return;
      }
      this.loading2 = true;
      // console.log(_this.boxInfo);
      let param = {
        mode: _this.mode,

        boxInfo: _this.boxInfo,
      };
      _this.$axios
        .post("/index/Battle/createRoom", _this.$qs.stringify(param))
        .then((res) => {
          // console.log(res);
          let data = res.data;
          // console.log(data);
          if (data.status == 1) {
            this.loading2 = false;
            this.$store.commit("getMoney", data.data.total_amount);
            Utils.$emit("money", data.data.total_amount);
           // _this.$bus.$emit("loading", true);

            //发送
            /* let sendData = {
               state: "add",
               battle_id: data.data.battle_id,
             };
             _this.websocketsend(JSON.stringify(sendData));*/

            _this.$router.push({
              path: `/LuckyRoom`,
              query: {
                id: data.data.battle_id,
              },
            });
          } else {
            //创建失败
            _this.$message({
              message: data.msg,
              type: "warning",
            });
            _this.boxInfo = [];
            let selectListCopy = [
              { state: false, name: "" },
              { state: false, name: "" },
              { state: false, name: "" },
              { state: false, name: "" },
              { state: false, name: "" },
              { state: false, name: "" },
            ];
            _this.selectList = selectListCopy;
            _this.currentBoxNum = 0;
            _this.totalPrice = 0;
            // console.log(this.boxList);
            for (let i = 0; i < this.boxList.length; i++) {
              this.boxList[i].num = 0;
            }
          }
        });
    },
    //点击挑战房间
    goLuckyRoom(id) {
      for (let i = 0; i < this.list.length; i++) {
        if (id == this.list[i].id) {
          if (this.list[i].status == 1) {
            if (!this.$store.state.token) {
              this.$store.commit("getLogin", true);
            } else {
              this.$router.push({
                path: `/LuckyRoom`,
                query: {
                  id: id,
                },
              });
            }
          } else {
            this.$router.push({
              path: `/LuckyRoom`,
              query: {
                id: id,
              },
            });
          }
        }
      }
    },
    goLuckyRule() {
      this.$router.push({
        path: `/zh/battles/htp`,
      });
    },
    //跳转至活动历史
    goLuckyHistory() {
      this.$router.push({
        path: `/zh/battles/history`,
      });
    },
    //右侧创建房间
    openDrawer() {
      this.drawer = true;
    },
    //选择几人模式
    selectPattern(name) {
      for (let i = 0; i < this.patternList.length; i++) {
        if (this.patternList[i].name == name) {
          this.patternList[i].state = true;
          this.mode = this.patternList[i].val;
        } else {
          this.patternList[i].state = false;
        }
      }
      // console.log(this.mode);
    },
    //选择盒子
    addBox(index, price) {
      if (this.currentBoxNum < 6) {
        this.currentBoxNum++;
        this.currentBoxTotalPrice = this.currentBoxTotalPrice + Number(price);
      }
      var boxnum = 0;
      for (let i = 0; i < this.boxList.length; i++) {
        boxnum += this.boxList[i].num;
      }
      if (boxnum < 6) {
        this.boxList[index].num += 1;
        //console.log(this.selectList)
        for (let i = 0; i < this.selectList.length; i++) {
          if (this.selectList[i].state == false) {
            this.selectList[i].state = true;
            this.selectList[i].box_id = this.boxList[index].id;
            this.selectList[i].name = this.boxList[index].name;
            this.selectList[i].price = this.boxList[index].price;
            this.selectList[i].img_main = this.boxList[index].img_main;
            break;
          }
        }
      } else {
        this.$notify({
          title: "提示",
          message: "盲盒数量已达上限",
        });
      }
      // console.log(this.selectList);
    },
    //去掉盒子
    remBox(name, price) {
      if (name) {
        if (this.currentBoxNum > 0) {
          this.currentBoxNum--;
          this.currentBoxTotalPrice = this.currentBoxTotalPrice - Number(price);
        }
      }
      for (let i = 0; i < this.boxList.length; i++) {
        if (name == this.boxList[i].name) {
          this.boxList[i].num--;
        }
      }
      for (let i = 0; i < this.selectList.length; i++) {
        if (this.selectList[i].name == name) {
          this.selectList[i].name = "";
          this.selectList[i].state = false;
          break;
        }
      }
      this.selectList.sort((a, b) => b.state - a.state);
    },
  },
  mounted() {
    let _this = this;
    _this.getBattleBoxList();
    _this.getList();
    _this.rankList();
    this.battleRefreshTimer = window.setInterval(() => {
      this.getList();
    }, 15000);
    this.$bus.$emit("loading", false);
    if (this.$route.path == "/zh/battles/create") {
      this.drawer = true;
    }

    Utils.$on("update", function (data) {
      _this.sockBattleList(data);
    });
  },
  beforeDestroy: function () {},
  created() {
    this.initWebSocket();
    this.is_mobile = this.isMobile();
    window.addEventListener("resize", () => {
      this.is_mobile = this.isMobile();
    });
  },
  destroyed() {
    //clearInterval(this.timer);
    if (this.websock && typeof this.websock.close === "function") {
      this.websock.close();
    }
    clearInterval(this.battleRefreshTimer);
  },
};
</script>

<style lang="less" scoped>
::v-deep {
  .el-drawer__body {
    padding: 10px 0px 10px 15px;
    background-color: #1a1a24;
    overflow-y: auto;
  }
  .el-drawer__header {
    background-color: #1a1a24;
    margin-bottom: 0;
    padding-bottom: 20px;
  }
}
.replace-room {
  transform-style: preserve-3d;
  backface-visibility: hidden;
  -webkit-animation-name: flip;
  animation-name: flip;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
}
@keyframes flip {
  0% {
    transform: scale(0.75);
  }

  50% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
.ranking {
  flex-grow: 1;
  flex-basis: 0;
  margin-right: 16px;
  .rank-top {
    background-color: #2b2c37;
    // padding: 20px;
    border-radius: 5px;
    padding: 35px 0;
    .one {
      text-align: center;
      font-size: 24px;
      color: #c3c3e2;
    }
    .two {
      // width: 60px;
      height: 60px;
      text-align: center;
      margin-top: 15px;
      position: relative;
      background: url(../assets/img/maisui.svg) center no-repeat;

      .winner-warp {
        width: 60px;
        height: 60px;
        // border-radius: 50%;
        //overflow: hidden;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -30px;
        z-index: 66;
      }
      .winner1 {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        // margin-left: -30px;
        z-index: 66;
      }
      .winner {
        width: 200px;
        height: 200px;
        position: absolute;
        top: -70px;
        left: -75px;
        animation: jss163 5000ms linear infinite;
        user-select: none;
        pointer-events: none;
        z-index: 2;
      }
      @-webkit-keyframes jss163 {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      span {
        position: absolute;
        left: 50%;
        bottom: 0;
        font-size: 12px;
        border-radius: 2px;
        padding: 0 6px;
        background-color: #858493;
        margin-left: -14px;
        z-index: 88;
      }
    }
    .three {
      margin-top: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin-left: 5px;
        color: #c3c3e2;
        font-size: 14px;
      }
      img {
        width: 15px;
        height: 15px;
      }
    }
    .four {
      text-align: center;
      margin-top: 5px;
      font-size: 16px;
      color: #e9b10e;
    }
  }
  .rank-bot {
    margin-top: 16px;
    background-color: #2b2c37;
    padding: 20px 10px;
    border-radius: 5px;
    .title {
      text-align: center;
      font-size: 20px;
      color: #c3c3e2;
    }
    .ranking-list {
      ul li {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

        .list-left {
          display: flex;
          align-items: center;
          .list-left1 {
            margin-right: 10px;
            position: relative;
            img {
              border-radius: 50%;
              width: 45px;
              height: 45px;
            }
            span {
              position: absolute;
              left: 50%;
              bottom: 0;
              font-size: 12px;
              border-radius: 2px;
              padding: 0 6px;
              background-color: #858493;
              margin-left: -14px;
            }
          }
          .list-left2 {
            display: flex;
            align-items: center;
            img {
              margin-right: 5px;
              width: 15px;
              height: 15px;
            }
            span {
              font-size: 14px;
              color: #c3c3e2;
            }
          }
        }
      }
      ul li:hover {
        cursor: pointer;
        background-color: #292a35;
      }
      /* ul li:active{
              background-color: #fff;
            } */
    }
    .list-right {
      font-size: 14px;
      color: #e9b10e;
    }
  }
}
.lucky {
  width: 100%;
  height: 100%;
  background-color: #1a1a24;
  overflow: hidden;
  overflow-y: auto;

  .lucky-warp {
    height: 100%;
    padding: 16px;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        color: #c3c3e2;
        font-size: 24px;
      }
      .right {
        display: flex;
        align-items: center;

        .right-span {
          padding: 9px 22px;
          border-radius: 5px;
          font-size: 15px;

          font-weight: 600;
        }
        .right-span1 {
          margin-right: 10px;
          background-color: #333542;
          color: #848492;
        }
        .right-span1:hover {
          background-color: #3a3f50;
          cursor: pointer;
        }
        .right-span2 {
          color: #1a1c42;
          background-color: #e9b10e;
        }
        .right-span2:hover {
          background-color: #f5c432;
          cursor: pointer;
        }
      }
    }

    .luc-list {
      height: 150px;
      margin-top: 20px;
      background-color: #2b2c37;
      ul {
        height: 100%;
        background-color: #2b2c37;
        border-radius: 5px;
        li {
          height: 100%;
          background-color: #2b2c37;
          float: left;
          width: 10%;
          .list-warp {
            height: 100%;
            padding-top: 10px;
            border-right: 1px solid #1a1c24;
            .list-img {
              text-align: center;
              img {
                // height: 80px;
                width: 100px;
                height: 75px;
              }
            }
            .list-money {
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                height: 15px;
                width: auto;
                margin-right: 5px;
              }
              span {
                color: #e9b10e;
              }
            }
            .list-name {
              text-align: center;
              margin-top: 5px;
              color: #c3c3e2;
              padding-bottom: 10px;
            }
          }
        }
        li:hover {
          cursor: pointer;
          background-color: #30313f;
        }
      }
    }

    .luc-list1 {
      display: none;
      height: 150px;
      margin-top: 20px;
      background-color: #2b2c37;
      width: 100%;
      //overflow: hidden;
      overflow-x: auto;
      ul {
        width: 1000px;
        background-color: #2b2c37;
        border-radius: 5px;
        overflow-y: hidden;
        li {
          background-color: #2b2c37;
          float: left;
          width: 100px;
          .list-warp {
            border-right: 1px solid #1a1c24;
            padding-top: 10px;
            .list-img {
              text-align: center;
              img {
                // height: 80px;
                width: 100px;
                height: auto;
              }
            }
            .list-money {
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                height: 15px;
                width: auto;
                margin-right: 5px;
              }
              span {
                color: #e9b10e;
              }
            }
            .list-name {
              text-align: center;
              margin-top: 5px;
              color: #c3c3e2;
              padding-bottom: 10px;
            }
          }
        }
        li:hover {
          cursor: pointer;
          background-color: #30313f;
        }
      }
    }

    .luc-list /deep/ .el-carousel__indicators--outside {
      display: none;
    }

    /* .luc-list::-webkit-scrollbar {
     
      width: 2000px; 
      height: 10px;
    }
    .luc-list::-webkit-scrollbar-thumb {
     
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #535353;
    }
    .luc-list::-webkit-scrollbar-track {
     
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #ededed;
    } */

    .hint {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      span {
        color: #848492;
        font-size: 14px;
      }
    }
    .room {
      padding-bottom: 50px;
      margin-top: 20px;
      display: flex;

      .bg_1 {
        background-image: url("../assets/new/await_1.png") !important;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .bg_2 {
        background-image: url("../assets/new/going.png") !important;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .bg_3 {
        background-image: url("../assets/new/end.png") !important;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .room-box {
        flex-grow: 3;
        flex-basis: 0;
        .room-box-ul {
          margin-top: -8px;
          display: grid;
          gap: 10px;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          li {
            height: 187px;
            cursor: pointer;
            .roombox-warp {
              margin: 8px;
              // background-color: #22222d;
              border-radius: 5px;

              .status-condiv {
                display: flex;
                flex-direction: row;
                align-items: center;
                color: #fff;
                font-size: 14px;
                .point {
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  background-color: #fff;
                  margin-right: 5px;
                }
                .point_1 {
                  background-color: #e9b10e;
                }
                .point_2 {
                  background-color: #67c23a;
                }
                .point_3 {
                  background-color: #999;
                }
                .text_1 {
                  color: #e9b10e;
                }
                .text_2 {
                  color: #67c23a;
                }
                .text_3 {
                  color: #999;
                }
              }

              .status-img {
                height: 17px;
              }

              .vs {
                width: 17px;
                height: 12px;
                margin: 0 5px 0 10px;
              }
              .vs-info {
                display: flex;
                align-items: center;
              }
              .card-footer {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 5px;
                .two-top {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 80px;

                  span {
                    margin-left: 5px;
                    font-size: 14px;
                    color: #e9b10e;
                  }
                  img {
                    height: 14px;
                    width: auto;
                  }
                }
              }

              .box-detail {
                position: relative;
                margin-right: 5px;
                .box-num {
                  position: absolute;
                  top: 0;
                  right: -5px;
                  width: 15px;
                  display: flex;
                  font-size: 12px;
                  align-items: center;
                  justify-content: center;
                  height: 15px;
                  border-radius: 50%;
                  background-color: #e9b10e;
                  color: #000;
                }
              }

              .one {
                height: 30px;
                display: flex;
                padding: 0 10px;
                align-items: center;
                justify-content: space-between;
                // background-color: #243438;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;

                .span1 {
                  color: #02bf4d;
                  font-size: 14px;
                  display: flex;
                  align-items: center;

                  .span-dian {
                    width: 8px;
                    height: 8px;
                    display: inline-block;
                    animation: jss684 500ms linear infinite alternate;
                    // box-shadow: 0 0  4px rgb(2 191 77 / 20%);
                    box-shadow: 0px 0px 15px rgba(255, 255, 255, 1);
                    margin-left: 10px;
                    margin-right: 10px;
                    border-radius: 4px;
                    vertical-align: middle;
                    background-color: #02bf4d;
                  }
                  @keyframes jss684 {
                    0% {
                      box-shadow: 0px 0px 10px rgba(255, 255, 255, 1);
                    }
                    100% {
                      box-shadow: 0px 0px 15px rgba(255, 255, 255, 1);
                    }
                  }
                }
                .span3 {
                  color: #c3c3e2;
                  font-size: 14px;
                }

                .status2 {
                  display: flex;
                  align-items: center;
                  .span2 {
                    color: #ae7bfe;
                    font-size: 14px;
                    margin-right: 5px;
                  }
                  .img1 {
                    animation: jss163 1000ms linear infinite;
                  }
                  @keyframes jss163 {
                    0% {
                      transform: rotate(0deg);
                    }
                    100% {
                      transform: rotate(360deg);
                    }
                  }
                }
              }

              .two1 {
                // background-image: linear-gradient(#2a2c37, #23463b);
              }
              .two2 {
                // background-image: linear-gradient(#2d2d36, #483856);
                opacity: 0.5;
                // background-image: url("../assets/new/going.png");
                // background-size: 100% 100%;
                // background-repeat: no-repeat;
              }
              .two3 {
                // background-image: linear-gradient(#2d2d36, #483856);
                // background-image: url("../assets/new/end.png");
                // background-size: 100% 100%;
              }
              .two {
                padding: 15px 0;

                .two-bot {
                  margin-top: 10px;
                  .room-peo {
                    // min-height: 124px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    .pk-warp {
                      margin-top: 10px;
                      display: flex;
                      align-items: center;
                      span:first-child {
                        margin-left: 10px;
                      }
                      .pk-tou {
                        margin: 0 5px;
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        //border: 1px dashed #e9b10e;
                        position: relative;
                        .image-border {
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                          width: 60px !important;
                          height: 60px !important;
                        }

                        .pk-true {
                          width: 40px;
                          height: 40px;
                          border-radius: 50%;
                        }
                        .pk-false {
                          width: 25px;
                          border-radius: 50%;
                          height: 25px;
                        }
                      }
                      .pk-tou-false {
                        border: 1px dashed #e9b10e;
                      }
                    }
                  }
                  .room-btn {
                    margin-top: 20px;
                    display: flex;
                    justify-content: center;
                    span {
                      border: 2px solid #e9b10e;
                      padding: 4px 50px;
                      border-radius: 30px;
                      color: #e9b10e;
                    }
                    /* span:hover {
                      cursor: pointer;
                    }*/
                    .span1:hover {
                      cursor: pointer;
                      background-color: rgba(233, 177, 14, 0.1);
                    }
                    .span2:hover {
                      cursor: pointer;
                      background-color: rgba(132, 132, 146, 0.2);
                    }
                  }
                }
              }
              .three {
                border-bottom-right-radius: 5px;
                border-bottom-left-radius: 5px;
                // background-color: #243438;
                display: flex;
                flex-wrap: nowrap;
                overflow-x: auto;
                margin-top: 10px;
                padding: 0 20px;

                img {
                  height: 30px;
                  width: auto;
                }
              }
              .three::-webkit-scrollbar {
                /*滚动条整体样式*/
                width: 10px;
                /*高宽分别对应横竖滚动条的尺寸*/
                height: 6px;
              }

              .three::-webkit-scrollbar-thumb {
                /*滚动条里面小方块*/
                border-radius: 10px;
                background-color: #4b575c;
              }

              .three::-webkit-scrollbar-track {
                /*滚动条里面轨道*/
                box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
                // background: #243438;
              }
            }
          }
          li:nth-child(4n + 1) .roombox-warp {
            margin-left: 0;
          }
          li:nth-child(4n) .roombox-warp {
            margin-right: 0;
          }
        }
      }

      .more-btn {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        span {
          color: #848492;
          font-size: 15px;
          padding: 9px 22px;
          border-radius: 5px;
          font-weight: 600;
          background-color: #333542;
        }
        span:hover {
          background-color: #3a3f50;
          cursor: pointer;
        }
      }
    }
  }
}
.sty {
  .sty-one {
    margin: 16px;
    .sty-one-hint {
      font-size: 14px;
      padding-bottom: 5px;
      color: #c3c3e2;
    }
    .sty-one-pattern {
      display: flex;
      span {
        width: 33.33%;
        text-align: center;
        background-color: #e9b10e;
        font-weight: 400;
        padding: 10px 0;
        font-size: 15px;
      }
      :first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      :last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
      :hover {
        cursor: pointer;
      }
      .span1 {
        background-color: #1f1f26;
        color: #848492;
      }
    }
  }
  .sty-two {
    margin: 16px;
    .sty-two-hint1 {
      font-size: 14px;
      color: #c3c3e2;
    }
    .sty-two-hint2 {
      font-size: 12px;
      padding-bottom: 5px;
      color: #848492;
    }
    .sty-two-list {
      ul {
        margin: 0 -2px;
        margin-right: 5px;
        display: flex;
        flex-flow: row wrap;
        li {
          margin-top: 5px;
          width: 33.33%;
          .twolist-warp {
            height: 100%;
            background: linear-gradient(
              101deg,
              rgba(132, 132, 146, 0) 0%,
              rgba(132, 132, 146, 0.2) 100%
            );
            border: 1px solid rgba(132, 132, 146, 0.2);
            margin: 2px;
            position: relative;

            .twolist-top {
              width: 100%;
              img {
                width: 100%;
                height: 60px;
              }
            }
            .twolist-bot {
              padding: 4px 0;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: auto;
                height: 15px;
              }
              span {
                margin-left: 5px;
                color: #e9b10e;
              }
            }
            .twolist-num {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              border: 1px solid #e9b10e;
              background-color: rgba(233, 177, 14, 0.3);
              color: #e9b10e;
            }
            .twolist-num1 {
              display: none;
            }
          }
        }
        :hover {
          cursor: pointer;
        }
      }
    }
    /*滚动条样式*/
    .sty-two-list::-webkit-scrollbar {
      width: 4px;
      /*height: 4px;*/
    }
    .sty-two-list::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.2);
    }
    .sty-two-list::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }
  }
  .sty-three {
    background-color: #2b2c37;
    padding: 16px;
    .sty-three-hint {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        color: #848492;
        font-size: 14px;
        strong {
          color: #e9b10e;
          font-weight: 200;
        }
      }
    }
    .sty-three-list {
      ul {
        margin: 0 -2px;
        display: flex;
        flex-flow: row wrap;
        li {
          width: 33.33%;
          .threelist-warp {
            height: 100px;
            margin: 2px;
            border: 1px solid rgba(132, 132, 146, 0.2);
            background-color: rgba(20, 20, 25, 0.2);

            .threelist-img {
              img {
                width: 100%;
                height: auto;
              }
            }
            .threelist-name {
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: auto;
                height: 15px;
              }
              span {
                margin-left: 5px;
                color: #e9b10e;
              }
            }
          }
        }
        :hover {
          cursor: pointer;
        }
      }
    }
    .sty-three-btn1 {
      display: flex;
      justify-content: center;
    }
    .sty-three-btn {
      text-align: center;
      padding: 10px 25px;
      border-radius: 5px;
      background-color: #e9b10e;
      font-size: 14px;
      margin-top: 30px;
      color: #1a1c24;
      font-weight: 600;
      border-color: #e9b10e;
    }
    .sty-three-btn:hover {
      background-color: #f5c432;
      cursor: pointer;
    }
  }
}

.sty {
  /deep/ .el-drawer__wrapper {
    top: 60px;
  }
  /deep/ .el-drawer__header {
    display: none;
  }
  /deep/ .el-drawer__body {
    background-color: #30313f;
  }
}

.ripple {
  position: relative;
  //隐藏溢出的径向渐变背景
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.ripple:after {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  //设置径向渐变
  background-image: radial-gradient(
    circle,
    rgb(163, 162, 162) 10%,
    transparent 10.01%
  );
  background-repeat: no-repeat;
  background-position: 50%;
  transform: scale(20, 20);
  opacity: 0;
  transition: transform 0.3s, opacity 0.5s;
}

.ripple:active:after {
  transform: scale(0, 0);
  opacity: 0.3;
  //设置初始状态
  transition: 0s;
}

.lucky /deep/ .el-drawer__open .el-drawer.rtl {
  overflow-y: auto;
}

//底部弹框
.box-bot {
  .box-img {
    .box-img-title {
      padding: 16px;
      span {
        font-size: 16px;
        color: #c3c3e2;
      }
      .span1 {
        color: #e9b10e;
      }
    }

    .box-img-list {
      padding: 0 16px;
      ul {
        display: flex;
        overflow: hidden;
        overflow-x: auto;
        li {
          width: 200px;
          margin-right: 16px;

          .box-img1 {
            width: 200px;
            height: 150px;
            background-image: url("../assets/img/box-skins-blue.jpg");
            background-size: 100% 100%;
            img {
              width: 200px;
              height: 150px;
            }
          }
          .box-img-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            background-color: #24252f;
            padding: 8px;
            font-size: 14px;
            color: #c3c3e2;
          }
          .list-pirce {
            padding: 10px 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .ico {
            position: absolute;
            top: 0;
            left: 0;
            font-size: 12px;
            color: #c3c3e2;
            background-color: rgba(0, 0, 0, 0.5);
            padding: 2px 4px;
          }
          .pirce-left {
            display: flex;
            align-items: center;

            img {
              width: auto;
              height: 15px;
            }
            span {
              color: #e9b10e;
              font-size: 16px;
            }
          }
          .pirce-right {
            color: #848492;
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

.pk-lucky-page {
  min-height: 100vh;
  height: auto;
  position: relative;
  overflow: visible;
  background:
    radial-gradient(circle at 54% 20%, rgba(128, 72, 255, 0.16), transparent 28%),
    radial-gradient(circle at 82% 36%, rgba(242, 105, 0, 0.16), transparent 28%),
    #1c1d29;
}

.pk-lucky-content {
  width: 100%;
  height: auto;
  min-height: calc(100vh - 198px);
  margin-left: 0;
  padding-top: 0;
  position: relative;
  z-index: 1;
  overflow: visible;
}

.pk-lucky-content::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 360px;
  pointer-events: none;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.025), transparent 72%),
    repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.025) 0 1px, transparent 1px 84px);
}

.pk-lucky-page .lucky-warp {
  max-width: 1180px;
  height: auto;
  margin: 0 auto;
  padding: 28px 24px 80px;
  position: relative;
  z-index: 2;
}

.pk-lucky-page .top {
  min-height: 54px;
  padding: 0 0 16px;
}

.pk-lucky-page .lucky-warp .top .left {
  font-size: 0;
}

.pk-lucky-page .lucky-warp .top .left::before {
  content: "对战房间";
  color: #f3f6fb;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0.04em;
}

.pk-lucky-page .lucky-warp .top .left::after {
  content: "";
  width: 18px;
  height: 18px;
  margin-left: 10px;
  display: inline-block;
  vertical-align: -2px;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-lucky-page .top .right {
  gap: 8px;
}

.pk-lucky-page .top .right .right-span {
  padding: 12px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 900;
}

.pk-lucky-page .top .right .right-span1 {
  margin-right: 0;
  color: #9aa4b6;
  background: #252836;
}

.pk-lucky-page .top .right .right-span2 {
  color: #fff;
  background: #f26900;
  box-shadow: 0 12px 26px rgba(242, 105, 0, 0.24);
}

.pk-lucky-page .luc-list {
  height: 170px;
  margin-top: 0;
  overflow: hidden;
  background: #20222f;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 10px;
}

.pk-lucky-page .luc-list ul,
.pk-lucky-page .luc-list ul li {
  background: transparent;
}

.pk-lucky-page .luc-list ul li {
  width: 128px;
}

.pk-lucky-page .luc-list .list-warp {
  padding-top: 12px;
  position: relative;
  border-right: 1px solid #2b2f3d;
  transition: background 0.18s ease;
}

.pk-lucky-page .luc-list .list-warp:hover {
  background: #292c3a;
}

.pk-lucky-page .luc-list .list-img img {
  width: 112px;
  height: 86px;
  object-fit: contain;
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.48));
}

.pk-lucky-page .luc-list .list-money img {
  width: 15px;
  height: 15px;
  content: url("../assets/pizzaking/pizza-token.svg");
}

.pk-lucky-page .luc-list .list-money span {
  color: #f26900;
  font-weight: 900;
}

.pk-lucky-page .luc-list .list-name {
  color: #dce2ee;
  font-size: 13px;
  font-weight: 800;
}

.pk-battle-empty {
  min-height: 112px;
  margin: 0 0 16px;
  display: grid;
  place-items: center;
  color: #8f99ad;
  background: linear-gradient(145deg, rgba(39, 42, 57, 0.92), rgba(29, 31, 43, 0.94));
  border: 1px solid rgba(126, 136, 164, 0.24);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
}

.pk-battle-empty-rooms {
  min-height: 158px;
  margin: 0;
}

.pk-battle-preview-cases {
  min-height: 170px;
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(6, minmax(120px, 1fr));
  gap: 10px;
  background: #20222f;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 10px;
}

.pk-preview-case-card {
  min-width: 0;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background:
    radial-gradient(circle at 50% 44%, rgba(126, 60, 255, 0.22), transparent 58%),
    #282b39;
  border-radius: 9px;
  cursor: pointer;
}

.pk-preview-case-card img {
  width: 118px;
  height: 78px;
  object-fit: contain;
  mix-blend-mode: screen;
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.48));
}

.pk-preview-case-card strong {
  max-width: 100%;
  color: #dce2ee;
  font-size: 13px;
  font-weight: 900;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pk-preview-case-card span {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #f26900;
  font-size: 13px;
  font-weight: 900;
}

.pk-preview-case-card i {
  width: 14px;
  height: 14px;
  display: block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-lucky-page .hint {
  margin: 16px 0 0;
  padding: 12px 16px;
  background: #171923;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 8px;
}

.pk-lucky-page .hint span {
  color: #7f899c;
  font-weight: 800;
}

.pk-lucky-page .room {
  margin-top: 16px;
  padding-bottom: 0;
  display: block;
}

.pk-lucky-page .room > .ranking {
  display: none;
}

.pk-lucky-page .room .room-box {
  width: 100%;
}

.pk-lucky-page .room .room-box .room-box-ul {
  margin-top: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
  gap: 12px;
}

.pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  height: 260px !important;
  padding: 0;
  background: none !important;
  border-radius: 10px;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  height: 100%;
  margin: 0;
  padding: 14px;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 42%, rgba(104, 68, 255, 0.16), transparent 45%),
    linear-gradient(180deg, #272a38, #20222f);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
  transition: transform 0.18s ease, border-color 0.18s ease;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp:hover {
  transform: translateY(-3px);
  border-color: rgba(242, 105, 0, 0.62);
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  content: "观看";
  height: 34px;
  min-width: 82px;
  padding: 0 16px;
  position: absolute;
  right: 14px;
  top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #f26900;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.04em;
}

.pk-lucky-page .room .roombox-warp .one {
  height: 40px;
  padding: 0;
  display: block;
  position: static;
  background: transparent;
}

.pk-lucky-page .room .roombox-warp .status-condiv {
  position: absolute;
  left: 14px;
  top: 16px;
  min-height: 28px;
  color: #dce2ee;
  font-size: 13px;
  font-weight: 900;
}

.pk-lucky-page .room .roombox-warp .status-condiv::before {
  content: "玩家";
  margin-right: 8px;
  color: #788296;
}

.pk-lucky-page .room .roombox-warp .status-condiv .point {
  display: none;
}

.pk-lucky-page .room .roombox-warp .status-condiv .text_1,
.pk-lucky-page .room .roombox-warp .status-condiv .text_2,
.pk-lucky-page .room .roombox-warp .status-condiv .text_3 {
  display: inline-block;
  color: #ffc038;
  font-size: 15px;
  line-height: 1;
}

.pk-lucky-page .room .roombox-warp .status-img {
  display: none;
}

.pk-lucky-page .room .roombox-warp .span3 {
  width: auto;
  margin-right: 0;
  position: absolute;
  left: 14px;
  right: auto;
  top: 42px;
  color: #8792a4;
  font-size: 13px;
  font-weight: 900;
  line-height: 15px;
  text-align: left;
}

.pk-lucky-page .room .roombox-warp .two {
  padding: 28px 0 12px;
}

.pk-lucky-page .room .roombox-warp .two .two-bot {
  margin-top: 0;
}

.pk-lucky-page .room .roombox-warp .room-peo {
  min-height: 64px;
}

.pk-lucky-page .room .roombox-warp .room-peo .pk-warp {
  margin-top: 0;
}

.pk-lucky-page .room .roombox-warp .pk-tou {
  width: 46px !important;
  height: 46px !important;
  margin: 0 4px !important;
  background: #343847;
  border: 2px solid #4c5264;
}

.pk-lucky-page .room .roombox-warp .pk-tou-false {
  border: 2px dashed #5c6375;
}

.pk-lucky-page .room .roombox-warp .pk-true {
  width: 46px !important;
  height: 46px !important;
  object-fit: contain;
  mix-blend-mode: screen;
}

.pk-lucky-page .room .roombox-warp .pk-false {
  width: 24px !important;
  height: 24px !important;
  opacity: 0.58;
}

.pk-lucky-page .room .roombox-warp .vs {
  width: 18px;
  height: 13px;
  opacity: 0.6;
  filter: grayscale(1);
}

.pk-lucky-page .room .roombox-warp .pk-vs-text {
  margin: 0 4px;
  color: #687286;
  font-size: 11px;
  font-weight: 900;
}

.pk-lucky-page .room .roombox-warp .card-footer {
  min-height: 82px;
  margin-top: 0;
  padding-top: 12px;
  border-top: 1px solid #343847;
}

.pk-lucky-page .room .roombox-warp .card-footer .three {
  max-width: calc(100% - 96px);
  margin-top: 0;
  padding: 0;
  gap: 8px;
  background: transparent;
}

.pk-lucky-page .room .roombox-warp .box-detail {
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #303443;
  border-radius: 8px;
}

.pk-lucky-page .room .roombox-warp .box-detail img {
  max-width: 46px;
  max-height: 42px;
  object-fit: contain;
  mix-blend-mode: screen;
}

.pk-lucky-page .room .roombox-warp .box-detail .box-num {
  top: -5px;
  right: -5px;
  color: #fff;
  background: #f26900;
  font-weight: 900;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top {
  width: auto;
  min-width: 76px;
  padding: 8px 10px;
  position: absolute;
  right: 14px;
  bottom: 14px;
  background: #171923;
  border-radius: 7px;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top img {
  width: 15px;
  height: 15px;
  content: url("../assets/pizzaking/pizza-token.svg");
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top span {
  color: #f26900;
  font-size: 15px;
  font-weight: 900;
}

.pk-lucky-page .room .more-btn span {
  color: #fff;
  background: #2b2f3d;
  border-radius: 8px;
  font-weight: 900;
}

.pk-lucky-page .room .pk-room-preview ~ .more-btn {
  display: none;
}

.pk-lucky-page .lucky-warp {
  max-width: 1420px;
}

.pk-lucky-page .room .room-box .room-box-ul {
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
}

.pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  height: 198px !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  padding: 18px 18px 14px;
  background:
    radial-gradient(circle at 44% 42%, rgba(121, 83, 255, 0.18), transparent 48%),
    linear-gradient(180deg, rgba(49, 52, 68, 0.98), rgba(34, 36, 49, 0.98));
  border-color: rgba(111, 119, 145, 0.42);
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  left: 128px;
  right: auto;
  top: 18px;
  height: 34px;
  min-width: 78px;
  color: #ffffff;
  background: transparent;
  border: 1px solid #74809a;
  box-shadow: none;
}

.pk-lucky-page .room .roombox-warp .status-condiv {
  left: 18px;
  top: 16px;
  width: 96px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
}

.pk-lucky-page .room .roombox-warp .status-condiv::before {
  display: block;
  margin: 0;
  color: #8d96aa;
  font-size: 13px;
  line-height: 1;
  letter-spacing: 0.03em;
}

.pk-lucky-page .room .roombox-warp .status-condiv .text_1,
.pk-lucky-page .room .roombox-warp .status-condiv .text_2,
.pk-lucky-page .room .roombox-warp .status-condiv .text_3 {
  font-size: 0;
}

.pk-lucky-page .room .roombox-warp .pk-player-count {
  display: block;
  color: #f4f7ff;
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count {
  position: absolute;
  right: 18px;
  top: 18px;
  color: #8d96aa;
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count::after {
  content: attr(data-price);
}

.pk-lucky-page .room .roombox-warp .span3 {
  display: none;
}

.pk-lucky-page .room .roombox-warp .two {
  padding: 56px 0 8px;
}

.pk-lucky-page .room .roombox-warp .room-peo {
  min-height: 50px;
}

.pk-lucky-page .room .roombox-warp .room-peo .pk-warp {
  display: flex;
  align-items: center;
}

.pk-lucky-page .room .roombox-warp .pk-tou {
  width: 42px !important;
  height: 42px !important;
  background:
    radial-gradient(circle, rgba(242, 105, 0, 0.18), transparent 62%),
    #343847;
}

.pk-lucky-page .room .roombox-warp .pk-true {
  width: 42px !important;
  height: 42px !important;
}

.pk-lucky-page .room .roombox-warp .card-footer {
  min-height: 60px;
  padding-top: 10px;
  border-top-color: rgba(116, 128, 154, 0.28);
}

.pk-lucky-page .room .roombox-warp .box-detail {
  width: 46px;
  height: 46px;
  flex-basis: 46px;
  background: rgba(24, 26, 37, 0.82);
}

.pk-lucky-page .room .roombox-warp .box-detail img {
  max-width: 40px;
  max-height: 36px;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top {
  right: 18px;
  bottom: 16px;
  min-width: 86px;
  justify-content: flex-end;
  background: transparent;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top span {
  color: #f4f7ff;
  font-size: 18px;
}

.pk-lucky-content {
  min-height: 100vh;
}

.pk-lucky-content::before {
  display: none;
}

.pk-lucky-page .lucky-warp {
  max-width: none;
  padding: 20px 24px 80px;
}

.pk-lucky-page .top {
  min-height: 62px;
  margin-bottom: 22px;
  padding: 0 0 18px;
  align-items: center;
  border-bottom: 1px solid rgba(111, 119, 145, 0.24);
}

.pk-lucky-page .lucky-warp .top .left::before {
  content: "箱子战斗";
  font-size: 22px;
}

.pk-lucky-page .lucky-warp .top .left::after,
.pk-lucky-page .luc-list,
.pk-lucky-page .hint,
.pk-battle-preview-cases {
  display: none !important;
}

.pk-battle-sort {
  margin-right: 12px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.pk-battle-sort span {
  color: #9ea7ba;
  font-size: 14px;
  font-weight: 900;
}

.pk-battle-sort span.active {
  color: #ffcf5d;
}

.pk-lucky-page .room {
  margin-top: 0;
}

.pk-lucky-page .room .room-box .room-box-ul {
  grid-template-columns: repeat(auto-fit, minmax(480px, 1fr));
  gap: 22px 20px;
}

.pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  height: 174px !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  padding: 0;
  background: #202231;
  border-color: rgba(64, 70, 92, 0.88);
  border-radius: 8px;
  box-shadow: none;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp:hover {
  transform: none;
  border-color: rgba(242, 105, 0, 0.58);
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::before {
  content: "";
  position: absolute;
  left: 6px;
  top: 12px;
  width: 5px;
  height: 5px;
  background: #f26900;
  border-radius: 50%;
  box-shadow: 0 0 12px rgba(242, 105, 0, 0.86);
  z-index: 4;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  left: auto;
  right: 44px;
  top: auto;
  bottom: 26px;
  height: 40px;
  min-width: 110px;
  color: #cfd6e8;
  background: transparent;
  border: 1px solid rgba(116, 128, 154, 0.58);
  border-radius: 7px;
  box-shadow: none;
  font-size: 15px;
}

.pk-lucky-page .room .roombox-warp .card-footer {
  min-height: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.pk-lucky-page .room .roombox-warp .card-footer .three {
  width: 58%;
  max-width: none;
  height: 100%;
  margin: 0;
  padding: 0;
  position: absolute;
  left: 0;
  top: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50%, 1fr));
  gap: 0;
  overflow: hidden;
  background: #242735;
}

.pk-lucky-page .room .roombox-warp .box-detail {
  width: auto;
  height: 174px;
  flex: none;
  position: relative;
  background:
    radial-gradient(circle at 50% 50%, rgba(126, 60, 255, 0.2), transparent 60%),
    #252836;
  border-right: 1px solid rgba(17, 19, 28, 0.72);
  border-radius: 0;
}

.pk-lucky-page .room .roombox-warp .box-detail img {
  max-width: 152px;
  max-height: 138px;
  filter: drop-shadow(0 18px 24px rgba(0, 0, 0, 0.55));
}

.pk-lucky-page .room .roombox-warp .box-detail .box-num {
  left: 18px;
  right: auto;
  top: 17px;
  color: #c5ccdb;
  background: transparent;
  font-size: 14px;
}

.pk-lucky-page .room .roombox-warp .box-detail .box-num::before {
  content: "x";
}

.pk-lucky-page .room .roombox-warp .two {
  padding: 0;
  position: absolute;
  left: 58%;
  right: 0;
  top: 0;
  bottom: 0;
}

.pk-lucky-page .room .roombox-warp .two .two-bot {
  height: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pk-lucky-page .room .roombox-warp .room-peo {
  min-height: 0;
  margin-top: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pk-lucky-page .room .roombox-warp .room-peo .pk-warp {
  display: flex;
  align-items: center;
}

.pk-lucky-page .room .roombox-warp .pk-tou {
  width: 23px !important;
  height: 23px !important;
  margin: 0 2px !important;
  background: #4d566d;
  border: 0;
}

.pk-lucky-page .room .roombox-warp .pk-tou-false {
  border: 0;
  outline: 1px solid rgba(116, 128, 154, 0.55);
  outline-offset: 2px;
}

.pk-lucky-page .room .roombox-warp .pk-true {
  width: 23px !important;
  height: 23px !important;
  object-fit: cover;
  mix-blend-mode: normal;
  border-radius: 50%;
}

.pk-lucky-page .room .roombox-warp .pk-false {
  width: 13px !important;
  height: 13px !important;
  opacity: 0.72;
}

.pk-lucky-page .room .roombox-warp .vs {
  width: 22px;
  height: 22px;
  margin: 0 3px;
  opacity: 1;
  filter: none;
}

.pk-lucky-page .room .roombox-warp .status-condiv {
  left: auto;
  right: 24px;
  top: 28px;
  width: auto;
  display: block;
  color: #dfe5f4;
  text-align: right;
}

.pk-lucky-page .room .roombox-warp .status-condiv::before {
  content: "玩家";
  display: inline;
  margin: 0;
  color: #dfe5f4;
  font-size: 16px;
}

.pk-lucky-page .room .roombox-warp .status-condiv .text_1,
.pk-lucky-page .room .roombox-warp .status-condiv .text_2,
.pk-lucky-page .room .roombox-warp .status-condiv .text_3 {
  font-size: 0;
}

.pk-lucky-page .room .roombox-warp .pk-player-count {
  display: inline;
  color: #f4f7ff;
  font-size: 16px;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count {
  left: calc(58% + 32px);
  right: auto;
  top: 82px;
  color: #28bfd7;
  font-size: 14px;
}

.pk-lucky-page .room .roombox-warp .span3 {
  display: none;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top {
  left: calc(58% + 32px);
  right: auto;
  top: 24px;
  bottom: auto;
  min-width: 0;
  padding: 0;
  background: transparent;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top span {
  color: #ffe45f;
  font-size: 17px;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top img {
  width: 15px;
  height: 15px;
}

.pk-lucky-page .sty /deep/ .el-drawer__body,
.pk-lucky-page /deep/ .el-drawer__body {
  background: #20222f;
}

.pk-lucky-page .lucky-warp {
  width: 100% !important;
  max-width: none !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 24px 24px 80px !important;
}

.pk-lucky-page .top {
  min-height: 58px !important;
  margin-bottom: 18px !important;
  padding: 0 0 18px !important;
  border-bottom: 1px solid rgba(86, 93, 118, 0.34) !important;
}

.pk-lucky-page .lucky-warp .top .left::before {
  content: "箱子战斗" !important;
  color: #f5f7fc !important;
  font-size: 24px !important;
  font-weight: 900 !important;
  letter-spacing: 0 !important;
}

.pk-lucky-page .top .right {
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
}

.pk-lucky-page .top .right .right-span {
  height: 36px !important;
  padding: 0 16px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

.pk-lucky-page .top .right .right-span1 {
  color: #c3cada !important;
  background: #252836 !important;
  border: 1px solid rgba(82, 90, 115, 0.72) !important;
}

.pk-lucky-page .top .right .right-span2 {
  min-width: 126px !important;
  color: #fff !important;
  background: #ff7a00 !important;
  border: 1px solid rgba(255, 159, 55, 0.34) !important;
  box-shadow: 0 12px 22px rgba(255, 122, 0, 0.18) !important;
}

.pk-battle-sort {
  height: 36px !important;
  margin-right: 6px !important;
  padding: 0 12px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 12px !important;
  background: #222532 !important;
  border: 1px solid rgba(73, 81, 106, 0.7) !important;
  border-radius: 6px !important;
}

.pk-battle-sort span {
  color: #8c95a8 !important;
  font-size: 13px !important;
  font-weight: 900 !important;
  white-space: nowrap !important;
}

.pk-battle-sort span.active {
  color: #ffd76a !important;
}

.pk-lucky-page .room {
  margin-top: 0 !important;
}

.pk-lucky-page .room .room-box,
.pk-lucky-page .room .room-box .room-box-ul {
  width: 100% !important;
}

.pk-lucky-page .room .room-box .room-box-ul {
  margin-top: 0 !important;
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 18px 20px !important;
}

.pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  height: 174px !important;
  min-width: 0 !important;
  padding: 0 !important;
  background: none !important;
  border-radius: 8px !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  width: 100% !important;
  height: 174px !important;
  margin: 0 !important;
  padding: 0 !important;
  position: relative !important;
  overflow: hidden !important;
  background: #202230 !important;
  border: 1px solid rgba(70, 77, 101, 0.9) !important;
  border-radius: 8px !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025) !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp:hover {
  transform: none !important;
  border-color: rgba(255, 122, 0, 0.58) !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::before {
  content: "" !important;
  position: absolute !important;
  left: 6px !important;
  top: 13px !important;
  width: 5px !important;
  height: 5px !important;
  z-index: 7 !important;
  background: #ff7a00 !important;
  border-radius: 50% !important;
  box-shadow: 0 0 11px rgba(255, 122, 0, 0.9) !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  content: "观看战斗  ◉" !important;
  position: absolute !important;
  right: 34px !important;
  bottom: 25px !important;
  left: auto !important;
  top: auto !important;
  width: auto !important;
  min-width: 116px !important;
  height: 38px !important;
  padding: 0 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #d8dfef !important;
  background: transparent !important;
  border: 1px solid rgba(110, 120, 151, 0.72) !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  font-size: 13px !important;
  font-weight: 900 !important;
  letter-spacing: 0 !important;
  line-height: 1 !important;
}

.pk-lucky-page .room .roombox-warp .one,
.pk-lucky-page .room .roombox-warp .two,
.pk-lucky-page .room .roombox-warp .card-footer {
  position: static !important;
  height: auto !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .three {
  width: 58% !important;
  height: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 0 !important;
  overflow: hidden !important;
  background: #252837 !important;
}

.pk-lucky-page .room .roombox-warp .box-detail {
  width: 100% !important;
  height: 174px !important;
  min-width: 0 !important;
  flex: none !important;
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important;
  background:
    radial-gradient(circle at 50% 46%, rgba(100, 49, 235, 0.26), transparent 58%),
    #262938 !important;
  border-right: 1px solid rgba(16, 18, 27, 0.72) !important;
  border-radius: 0 !important;
}

.pk-lucky-page .room .roombox-warp .box-detail:only-child {
  grid-column-start: 1 !important;
  grid-column-end: -1 !important;
}

.pk-lucky-page .room .roombox-warp .box-detail img {
  width: 86% !important;
  height: 126px !important;
  max-width: none !important;
  max-height: none !important;
  object-fit: contain !important;
  mix-blend-mode: normal !important;
  filter: drop-shadow(0 18px 20px rgba(0, 0, 0, 0.55)) !important;
}

.pk-lucky-page .room .roombox-warp .box-detail .box-num {
  position: absolute !important;
  left: 18px !important;
  right: auto !important;
  top: 17px !important;
  min-width: 0 !important;
  padding: 0 !important;
  color: #c9cfdd !important;
  background: transparent !important;
  border: 0 !important;
  font-size: 14px !important;
  font-weight: 900 !important;
  line-height: 1 !important;
}

.pk-lucky-page .room .roombox-warp .box-detail .box-num::before {
  content: "x" !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top {
  position: absolute !important;
  left: calc(58% + 26px) !important;
  right: auto !important;
  top: 25px !important;
  bottom: auto !important;
  width: auto !important;
  min-width: 0 !important;
  height: 20px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 5px !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top img {
  width: 15px !important;
  height: 15px !important;
  content: url("../assets/pizzaking/pizza-token.svg") !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top span {
  color: #ffd655 !important;
  font-size: 16px !important;
  font-weight: 900 !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv {
  position: absolute !important;
  left: auto !important;
  right: 24px !important;
  top: 25px !important;
  width: auto !important;
  min-height: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  color: #dfe5f2 !important;
  text-align: right !important;
  z-index: 5 !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv::before {
  content: "玩家" !important;
  margin: 0 !important;
  color: #dfe5f2 !important;
  font-size: 16px !important;
  font-weight: 900 !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv .point,
.pk-lucky-page .room .roombox-warp .status-img {
  display: none !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv .text_1,
.pk-lucky-page .room .roombox-warp .status-condiv .text_2,
.pk-lucky-page .room .roombox-warp .status-condiv .text_3 {
  display: inline !important;
  color: #f3f6ff !important;
  font-size: 0 !important;
  line-height: 1 !important;
}

.pk-lucky-page .room .roombox-warp .pk-player-count {
  color: #f3f6ff !important;
  font-size: 16px !important;
  font-weight: 900 !important;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count {
  position: absolute !important;
  left: calc(58% + 26px) !important;
  right: auto !important;
  top: 83px !important;
  width: auto !important;
  color: #20bfd9 !important;
  font-size: 14px !important;
  font-weight: 900 !important;
  line-height: 1 !important;
  text-transform: uppercase !important;
  z-index: 5 !important;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count::before {
  content: "" !important;
  width: 28px !important;
  height: 2px !important;
  margin-right: 8px !important;
  display: inline-block !important;
  vertical-align: 4px !important;
  background: #20bfd9 !important;
  box-shadow: 0 0 12px rgba(32, 191, 217, 0.62) !important;
}

.pk-lucky-page .room .roombox-warp .span3 {
  display: none !important;
}

.pk-lucky-page .room .roombox-warp .two {
  position: absolute !important;
  left: 58% !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  width: auto !important;
  height: 100% !important;
  z-index: 4 !important;
}

.pk-lucky-page .room .roombox-warp .two .two-bot {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.pk-lucky-page .room .roombox-warp .room-peo {
  min-height: 0 !important;
  margin: 30px 0 0 !important;
  padding: 0 18px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.pk-lucky-page .room .roombox-warp .room-peo .pk-warp {
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
}

.pk-lucky-page .room .roombox-warp .pk-tou {
  width: 23px !important;
  height: 23px !important;
  margin: 0 2px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important;
  background: #4e566b !important;
  border: 0 !important;
  border-radius: 50% !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li,
.pk-lucky-page .room .roombox-warp,
.pk-lucky-page .room .roombox-warp .one,
.pk-lucky-page .room .roombox-warp .two,
.pk-lucky-page .room .roombox-warp .three {
  opacity: 1 !important;
}

.pk-lucky-page .room .roombox-warp .room-peo img[src^="data:image"] {
  display: none !important;
}

.pk-lucky-page .room .roombox-warp .room-peo .pk-tou {
  background:
    url("../assets/pizzaking/pizza-token.svg") center / 13px 13px no-repeat,
    #4e566b !important;
}

.pk-lucky-page .room .roombox-warp .pk-tou-false {
  outline: 1px solid rgba(116, 126, 154, 0.58) !important;
  outline-offset: 2px !important;
}

.pk-lucky-page .room .roombox-warp .pk-true {
  width: 23px !important;
  height: 23px !important;
  object-fit: cover !important;
  mix-blend-mode: normal !important;
  border-radius: 50% !important;
}

.pk-lucky-page .room .roombox-warp .pk-false {
  width: 13px !important;
  height: 13px !important;
  opacity: 0.68 !important;
}

.pk-lucky-page .room .roombox-warp .vs {
  display: none !important;
}

.pk-lucky-page .room .roombox-warp img {
  opacity: 1 !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  border-color: rgba(74, 80, 104, 0.94) !important;
  border-bottom-color: rgba(255, 108, 22, 0.86) !important;
  box-shadow:
    inset 0 -1px 0 rgba(255, 108, 22, 0.62),
    inset 0 1px 0 rgba(255, 255, 255, 0.025),
    0 0 0 1px rgba(26, 28, 40, 0.5) !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  right: 42px !important;
  bottom: 14px !important;
  min-width: 150px !important;
  height: 38px !important;
  z-index: 30 !important;
  pointer-events: none !important;
  color: #f6f7fb !important;
  background: rgba(33, 36, 51, 0.72) !important;
  border-color: rgba(111, 121, 151, 0.72) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.04),
    0 10px 20px rgba(0, 0, 0, 0.18) !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .three {
  background:
    linear-gradient(180deg, rgba(40, 43, 58, 0.98), rgba(34, 36, 50, 0.98)) !important;
}

.pk-lucky-page .room .roombox-warp .box-detail {
  --pk-case-rgb: 147, 88, 255;
  --pk-case-bottom-rgb: 255, 94, 38;
  background:
    radial-gradient(ellipse at 50% 67%, rgba(var(--pk-case-bottom-rgb), 0.26), transparent 58%),
    radial-gradient(circle at 51% 48%, rgba(var(--pk-case-rgb), 0.26), transparent 45%),
    linear-gradient(180deg, #252838 0%, #242736 58%, rgba(59, 39, 39, 0.85) 100%) !important;
  box-shadow:
    inset -1px 0 0 rgba(17, 19, 28, 0.8),
    inset 0 -1px 0 rgba(255, 108, 22, 0.58) !important;
}

.pk-lucky-page .room .roombox-warp .box-detail::before,
.pk-lucky-page .room .roombox-warp .box-detail::after {
  content: "" !important;
  position: absolute !important;
  pointer-events: none !important;
}

.pk-lucky-page .room .roombox-warp .box-detail::before {
  left: 8% !important;
  right: 8% !important;
  top: 12% !important;
  bottom: 6% !important;
  z-index: 0 !important;
  background:
    radial-gradient(ellipse at 50% 58%, rgba(var(--pk-case-rgb), 0.56), transparent 44%),
    radial-gradient(ellipse at 50% 72%, rgba(var(--pk-case-bottom-rgb), 0.28), transparent 55%) !important;
  filter: blur(10px) !important;
  opacity: 0.9 !important;
  mix-blend-mode: screen !important;
}

.pk-lucky-page .room .roombox-warp .box-detail::after {
  width: 78% !important;
  height: 56% !important;
  left: 11% !important;
  top: 20% !important;
  z-index: 1 !important;
  border: 2px solid rgba(var(--pk-case-rgb), 0.72) !important;
  border-left-color: rgba(var(--pk-case-rgb), 0.18) !important;
  border-bottom-color: rgba(var(--pk-case-bottom-rgb), 0.46) !important;
  border-radius: 50% !important;
  transform: rotate(-14deg) !important;
  filter:
    drop-shadow(0 0 8px rgba(var(--pk-case-rgb), 0.86))
    drop-shadow(0 8px 14px rgba(var(--pk-case-bottom-rgb), 0.28)) !important;
  opacity: 0.82 !important;
  mix-blend-mode: screen !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 1) .box-detail {
  --pk-case-rgb: 148, 84, 255;
  --pk-case-bottom-rgb: 255, 112, 35;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 2) .box-detail {
  --pk-case-rgb: 38, 214, 169;
  --pk-case-bottom-rgb: 255, 112, 35;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 3) .box-detail {
  --pk-case-rgb: 255, 65, 112;
  --pk-case-bottom-rgb: 255, 105, 34;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 4) .box-detail {
  --pk-case-rgb: 255, 206, 42;
  --pk-case-bottom-rgb: 255, 120, 28;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 5) .box-detail {
  --pk-case-rgb: 74, 232, 48;
  --pk-case-bottom-rgb: 255, 124, 30;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 6) .box-detail {
  --pk-case-rgb: 76, 187, 255;
  --pk-case-bottom-rgb: 255, 102, 38;
}

.pk-lucky-page .room .roombox-warp .box-detail:nth-child(2n) {
  --pk-case-rgb: 43, 214, 164;
}

.pk-lucky-page .room .roombox-warp .box-detail:nth-child(3n) {
  --pk-case-rgb: 255, 67, 112;
}

.pk-lucky-page .room .roombox-warp .box-detail img {
  width: 90% !important;
  height: 150px !important;
  position: relative !important;
  z-index: 2 !important;
  content: url("../assets/hotpizza/hp-case-purple-transparent.png") !important;
  mix-blend-mode: normal !important;
  filter:
    saturate(1.12)
    contrast(1.04)
    drop-shadow(0 20px 20px rgba(0, 0, 0, 0.6))
    drop-shadow(0 0 16px rgba(var(--pk-case-rgb), 0.55)) !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 2) .box-detail img {
  content: url("../assets/hotpizza/hp-case-green.png") !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 3) .box-detail img {
  content: url("../assets/hotpizza/hp-case-fire.png") !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 4) .box-detail img {
  content: url("../assets/hotpizza/hp-case-orange.png") !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 5) .box-detail img {
  content: url("../assets/hotpizza/hp-case-ice.png") !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li:nth-child(6n + 6) .box-detail img {
  content: url("../assets/hotpizza/hp-case-crystal.png") !important;
}

.pk-lucky-page .room .roombox-warp .box-detail:nth-child(2n) img {
  content: url("../assets/hotpizza/hp-case-green.png") !important;
}

.pk-lucky-page .room .roombox-warp .box-detail:nth-child(3n) img {
  content: url("../assets/hotpizza/hp-case-fire.png") !important;
}

.pk-lucky-page .room .roombox-warp .box-detail .box-num {
  z-index: 4 !important;
  color: #bfc6d6 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.55) !important;
}

.pk-lucky-page .room .roombox-warp .two {
  background:
    linear-gradient(90deg, rgba(32, 34, 48, 0.98), rgba(29, 31, 44, 0.98)) !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top {
  left: calc(58% + 28px) !important;
  top: 30px !important;
  z-index: 8 !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top span {
  font-size: 17px !important;
  text-shadow: 0 0 10px rgba(255, 195, 52, 0.36) !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv {
  right: 24px !important;
  top: 30px !important;
  z-index: 8 !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv::before,
.pk-lucky-page .room .roombox-warp .pk-player-count {
  font-size: 16px !important;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.18) !important;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count {
  left: calc(58% + 28px) !important;
  top: 76px !important;
  z-index: 8 !important;
  color: #21d7ec !important;
  font-size: 15px !important;
  text-shadow: 0 0 11px rgba(33, 215, 236, 0.5) !important;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count::before {
  width: 32px !important;
  height: 2px !important;
  margin-right: 9px !important;
  background: linear-gradient(90deg, rgba(33, 215, 236, 0), #21d7ec) !important;
  box-shadow: 0 0 13px rgba(33, 215, 236, 0.72) !important;
}

.pk-lucky-page .room .roombox-warp .room-peo {
  position: absolute !important;
  left: calc(58% + 56px) !important;
  right: 52px !important;
  top: 94px !important;
  min-height: 24px !important;
  height: 24px !important;
  margin: 0 !important;
  padding: 0 !important;
  z-index: 9 !important;
}

.pk-lucky-page .room .roombox-warp .pk-tou {
  width: 24px !important;
  height: 24px !important;
  margin: 0 2px !important;
  background:
    url("../assets/pizzaking/pizza-token.svg") center / 13px 13px no-repeat,
    radial-gradient(circle, rgba(86, 93, 118, 0.95), rgba(45, 49, 67, 0.95)) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.12),
    0 0 0 1px rgba(108, 119, 150, 0.62),
    0 0 12px rgba(255, 122, 0, 0.2) !important;
}

.pk-lucky-page .room .roombox-warp .pk-tou-false {
  outline: 1px solid rgba(121, 132, 164, 0.82) !important;
  outline-offset: 2px !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  right: 32px !important;
  bottom: 31px !important;
  min-width: 152px !important;
  height: 38px !important;
  z-index: 40 !important;
  color: #ffffff !important;
  background:
    linear-gradient(180deg, rgba(41, 45, 62, 0.78), rgba(34, 37, 53, 0.78)) !important;
  border: 1px solid rgba(123, 133, 163, 0.78) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 0 0 1px rgba(15, 17, 28, 0.28),
    0 8px 18px rgba(0, 0, 0, 0.22) !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45) !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top {
  left: calc(58% + 26px) !important;
  top: 30px !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv {
  right: 24px !important;
  top: 31px !important;
  min-width: 96px !important;
  justify-content: flex-end !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv::before {
  content: none !important;
}

.pk-lucky-page .room .roombox-warp .pk-player-label {
  display: inline-flex !important;
  color: #f3f6ff !important;
  font-size: 16px !important;
  font-weight: 900 !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.18) !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv > .pk-player-count {
  display: none !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv > [class^="text_"] {
  display: none !important;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count {
  left: calc(58% + 26px) !important;
  top: 74px !important;
}

.pk-lucky-page .room .roombox-warp .room-peo {
  left: auto !important;
  right: 31px !important;
  top: 70px !important;
  width: 58px !important;
  min-width: 58px !important;
  height: 30px !important;
  justify-content: flex-end !important;
  z-index: 41 !important;
}

.pk-lucky-page .room .roombox-warp .room-peo .pk-warp {
  margin-left: -2px !important;
}

.pk-lucky-page .room .roombox-warp .pk-tou {
  width: 26px !important;
  height: 26px !important;
  margin: 0 0 0 4px !important;
  background:
    url("../assets/pizzaking/pizza-token.svg") center / 14px 14px no-repeat,
    radial-gradient(circle at 50% 38%, rgba(101, 109, 137, 0.98), rgba(45, 49, 67, 0.98)) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.18),
    0 0 0 1px rgba(126, 137, 170, 0.76),
    0 0 11px rgba(255, 132, 35, 0.22) !important;
}

.pk-lucky-page .room .roombox-warp .pk-tou-false {
  outline: 1px solid rgba(126, 137, 170, 0.82) !important;
  outline-offset: 1px !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  background:
    linear-gradient(90deg, #202331 0 58%, #1f2230 58% 100%) !important;
}

.pk-lucky-page .room .roombox-warp .two {
  background: transparent !important;
}

.pk-lucky-page .room .roombox-warp .box-detail {
  background:
    radial-gradient(ellipse at 50% 76%, rgba(var(--pk-case-bottom-rgb), 0.38), transparent 56%),
    radial-gradient(circle at 49% 48%, rgba(var(--pk-case-rgb), 0.36), transparent 48%),
    linear-gradient(180deg, #292b39 0%, #262837 55%, rgba(80, 46, 42, 0.9) 100%) !important;
}

.pk-lucky-page .room .roombox-warp .box-detail::before {
  left: 4% !important;
  right: 4% !important;
  top: 3% !important;
  bottom: -2% !important;
  background:
    radial-gradient(ellipse at 50% 50%, rgba(var(--pk-case-rgb), 0.48), transparent 38%),
    radial-gradient(ellipse at 50% 82%, rgba(var(--pk-case-bottom-rgb), 0.38), transparent 58%) !important;
  filter: blur(12px) !important;
}

.pk-lucky-page .room .roombox-warp .box-detail::after {
  width: 84% !important;
  height: 61% !important;
  left: 8% !important;
  top: 17% !important;
  border-width: 2px !important;
  opacity: 0.9 !important;
}

.pk-lucky-page .room .roombox-warp .box-detail img {
  width: 98% !important;
  height: 160px !important;
  transform: translateY(3px) !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv {
  position: absolute !important;
  left: auto !important;
  right: 24px !important;
  top: 30px !important;
  width: 124px !important;
  min-width: 124px !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 7px !important;
  overflow: visible !important;
  color: #f3f6ff !important;
  text-align: right !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  z-index: 45 !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv::before {
  content: none !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv .point,
.pk-lucky-page .room .roombox-warp .status-img,
.pk-lucky-page .room .roombox-warp .status-condiv > .pk-player-count,
.pk-lucky-page .room .roombox-warp .status-condiv > [class^="text_"] {
  display: none !important;
}

.pk-lucky-page .room .roombox-warp .pk-player-label,
.pk-lucky-page .room .roombox-warp .pk-player-value {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  flex: 0 0 auto !important;
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  overflow: visible !important;
  color: #f3f6ff !important;
  font-size: 16px !important;
  font-weight: 900 !important;
  line-height: 1 !important;
  letter-spacing: 0 !important;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.18) !important;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count {
  left: calc(58% + 20px) !important;
  top: 76px !important;
  max-width: 86px !important;
  z-index: 43 !important;
}

.pk-lucky-page .room .roombox-warp .room-peo {
  right: 24px !important;
  top: 70px !important;
  width: 84px !important;
  min-width: 84px !important;
  height: 24px !important;
  z-index: 44 !important;
}

.pk-lucky-page .room .roombox-warp .room-peo .pk-warp {
  margin-left: -7px !important;
}

.pk-lucky-page .room .roombox-warp .pk-vs-text {
  display: none !important;
}

.pk-lucky-page .room .roombox-warp .pk-tou {
  width: 21px !important;
  height: 21px !important;
  margin: 0 !important;
}

.pk-lucky-page .room .roombox-warp .pk-tou img {
  width: 100% !important;
  height: 100% !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  right: 32px !important;
  bottom: 29px !important;
  z-index: 46 !important;
}

/deep/ .sty .el-drawer.rtl {
  width: 392px !important;
  top: 0 !important;
  background:
    radial-gradient(circle at 78% 12%, rgba(255, 122, 0, 0.2), transparent 34%),
    radial-gradient(circle at 0 44%, rgba(29, 216, 232, 0.08), transparent 36%),
    #171923 !important;
  border-left: 1px solid rgba(255, 122, 0, 0.42) !important;
  box-shadow: -24px 0 54px rgba(0, 0, 0, 0.42) !important;
}

/deep/ .sty .el-drawer__header {
  display: none !important;
}

/deep/ .sty .el-drawer__body {
  height: 100% !important;
  padding: 0 !important;
  overflow: hidden !important;
  background: transparent !important;
}

/deep/ .sty .sty-warp {
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  color: #f3f6ff !important;
}

/deep/ .sty .sty-warp::before {
  content: "CREATE BATTLE";
  height: 72px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 0.02em;
  border-bottom: 1px solid rgba(84, 93, 122, 0.45);
  background: linear-gradient(180deg, rgba(38, 41, 56, 0.9), rgba(24, 26, 38, 0.78));
}

/deep/ .sty .sty-one,
/deep/ .sty .sty-two,
/deep/ .sty .sty-three {
  margin: 0 !important;
  padding: 20px 22px !important;
  background: transparent !important;
  border-bottom: 1px solid rgba(80, 89, 116, 0.36) !important;
}

/deep/ .sty .sty-one-hint,
/deep/ .sty .sty-two-hint1 {
  margin-bottom: 12px !important;
  color: #f2f5ff !important;
  font-size: 14px !important;
  font-weight: 900 !important;
}

/deep/ .sty .sty-two-hint2 {
  margin-top: -8px !important;
  margin-bottom: 13px !important;
  color: #858fa6 !important;
  font-size: 12px !important;
  font-weight: 800 !important;
}

/deep/ .sty .sty-one-pattern {
  gap: 8px !important;
}

/deep/ .sty .sty-one-pattern span {
  height: 46px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #12151f !important;
  background:
    linear-gradient(180deg, #ff9a1b, #ff6f00) !important;
  border: 1px solid rgba(255, 185, 84, 0.48) !important;
  border-radius: 8px !important;
  box-shadow: 0 14px 26px rgba(255, 122, 0, 0.2) !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

/deep/ .sty .sty-one-pattern .span1 {
  color: #aab3c6 !important;
  background: #252836 !important;
  border-color: rgba(92, 102, 132, 0.56) !important;
  box-shadow: none !important;
}

/deep/ .sty .sty-two {
  min-height: 0 !important;
  flex: 1 1 auto !important;
}

/deep/ .sty .sty-two-list {
  height: calc(100vh - 388px) !important;
  min-height: 210px !important;
  padding-right: 4px !important;
  overflow-y: auto !important;
}

/deep/ .sty .sty-two-list ul {
  margin: 0 !important;
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 10px !important;
}

/deep/ .sty .sty-two-list ul li {
  width: auto !important;
  margin: 0 !important;
}

/deep/ .sty .twolist-warp {
  min-height: 136px !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  background:
    radial-gradient(circle at 50% 38%, rgba(29, 216, 232, 0.16), transparent 46%),
    linear-gradient(180deg, #282b3a, #202331) !important;
  border: 1px solid rgba(91, 101, 132, 0.5) !important;
  border-radius: 10px !important;
  overflow: hidden !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04) !important;
}

/deep/ .sty .twolist-top {
  height: 94px !important;
  display: grid !important;
  place-items: center !important;
}

/deep/ .sty .twolist-top img {
  width: 118px !important;
  height: 88px !important;
  object-fit: contain !important;
  filter: drop-shadow(0 16px 18px rgba(0, 0, 0, 0.46)) !important;
}

/deep/ .sty .twolist-bot,
/deep/ .sty .threelist-name {
  height: 34px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 5px !important;
  background: rgba(18, 21, 31, 0.38) !important;
}

/deep/ .sty .twolist-bot img,
/deep/ .sty .threelist-name img {
  width: 14px !important;
  height: 14px !important;
  content: url("../assets/pizzaking/pizza-token.svg") !important;
}

/deep/ .sty .twolist-bot span,
/deep/ .sty .threelist-name span {
  margin: 0 !important;
  color: #ffd76a !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

/deep/ .sty .twolist-num {
  inset: 0 !important;
  display: flex !important;
  align-items: flex-start !important;
  justify-content: flex-end !important;
  padding: 9px !important;
  color: #fff !important;
  background:
    linear-gradient(180deg, rgba(255, 122, 0, 0.1), rgba(255, 122, 0, 0.24)) !important;
  border: 1px solid #ff7a00 !important;
  border-radius: 10px !important;
  box-shadow:
    inset 0 0 0 1px rgba(255, 202, 128, 0.18),
    0 0 22px rgba(255, 122, 0, 0.22) !important;
  font-size: 14px !important;
  font-weight: 900 !important;
}

/deep/ .sty .sty-three {
  flex: 0 0 auto !important;
  border-bottom: 0 !important;
  background:
    linear-gradient(180deg, rgba(39, 42, 57, 0.95), rgba(24, 26, 38, 0.96)) !important;
}

/deep/ .sty .sty-three-hint {
  margin-bottom: 12px !important;
}

/deep/ .sty .sty-three-hint span {
  color: #8d97ad !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

/deep/ .sty .sty-three-hint strong {
  color: #ffd76a !important;
  font-weight: 900 !important;
}

/deep/ .sty .sty-three-list ul {
  margin: 0 !important;
  display: grid !important;
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  gap: 7px !important;
}

/deep/ .sty .sty-three-list ul li {
  width: auto !important;
}

/deep/ .sty .threelist-warp {
  height: 58px !important;
  margin: 0 !important;
  display: grid !important;
  place-items: center !important;
  background: #202331 !important;
  border: 1px solid rgba(88, 98, 128, 0.5) !important;
  border-radius: 8px !important;
  overflow: hidden !important;
}

/deep/ .sty .threelist-img img {
  width: 48px !important;
  height: 35px !important;
  object-fit: contain !important;
}

/deep/ .sty .threelist-name {
  display: none !important;
}

/deep/ .sty .sty-three-btn1 {
  margin-top: 16px !important;
}

/deep/ .sty .sty-three-btn {
  width: 100% !important;
  height: 48px !important;
  margin: 0 !important;
  padding: 0 !important;
  color: #fff !important;
  background:
    linear-gradient(180deg, #ff9a1b, #ff6f00) !important;
  border: 1px solid rgba(255, 185, 84, 0.5) !important;
  border-radius: 8px !important;
  box-shadow: 0 16px 30px rgba(255, 122, 0, 0.28) !important;
  font-size: 15px !important;
  font-weight: 900 !important;
}

.sty {
  /deep/ .el-drawer.rtl {
    width: 392px !important;
    top: 0 !important;
    background:
      radial-gradient(circle at 78% 12%, rgba(255, 122, 0, 0.2), transparent 34%),
      radial-gradient(circle at 0 44%, rgba(29, 216, 232, 0.08), transparent 36%),
      #171923 !important;
    border-left: 1px solid rgba(255, 122, 0, 0.42) !important;
    box-shadow: -24px 0 54px rgba(0, 0, 0, 0.42) !important;
  }

  /deep/ .el-drawer__body {
    height: 100% !important;
    padding: 0 !important;
    overflow: hidden !important;
    background: transparent !important;
  }

  /deep/ .sty-warp {
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    color: #f3f6ff !important;
  }

  /deep/ .sty-warp::before {
    content: "CREATE BATTLE";
    height: 72px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    color: #ffffff;
    font-size: 22px;
    font-weight: 900;
    letter-spacing: 0.02em;
    border-bottom: 1px solid rgba(84, 93, 122, 0.45);
    background: linear-gradient(180deg, rgba(38, 41, 56, 0.9), rgba(24, 26, 38, 0.78));
  }

  /deep/ .sty-one,
  /deep/ .sty-two,
  /deep/ .sty-three {
    margin: 0 !important;
    padding: 20px 22px !important;
    background: transparent !important;
    border-bottom: 1px solid rgba(80, 89, 116, 0.36) !important;
  }

  /deep/ .sty-one-hint,
  /deep/ .sty-two-hint1 {
    margin-bottom: 12px !important;
    color: #f2f5ff !important;
    font-size: 14px !important;
    font-weight: 900 !important;
  }

  /deep/ .sty-two-hint2 {
    margin-top: -8px !important;
    margin-bottom: 13px !important;
    color: #858fa6 !important;
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  /deep/ .sty-one-pattern {
    gap: 8px !important;
  }

  /deep/ .sty-one-pattern span {
    height: 46px !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #12151f !important;
    background: linear-gradient(180deg, #ff9a1b, #ff6f00) !important;
    border: 1px solid rgba(255, 185, 84, 0.48) !important;
    border-radius: 8px !important;
    box-shadow: 0 14px 26px rgba(255, 122, 0, 0.2) !important;
    font-size: 13px !important;
    font-weight: 900 !important;
  }

  /deep/ .sty-one-pattern .span1 {
    color: #aab3c6 !important;
    background: #252836 !important;
    border-color: rgba(92, 102, 132, 0.56) !important;
    box-shadow: none !important;
  }

  /deep/ .sty-two {
    min-height: 0 !important;
    flex: 1 1 auto !important;
  }

  /deep/ .sty-two-list {
    height: calc(100vh - 388px) !important;
    min-height: 210px !important;
    padding-right: 4px !important;
    overflow-y: auto !important;
  }

  /deep/ .sty-two-list ul {
    margin: 0 !important;
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }

  /deep/ .sty-two-list ul li {
    width: auto !important;
    margin: 0 !important;
  }

  /deep/ .twolist-warp {
    min-height: 136px !important;
    margin: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-between !important;
    background:
      radial-gradient(circle at 50% 38%, rgba(29, 216, 232, 0.16), transparent 46%),
      linear-gradient(180deg, #282b3a, #202331) !important;
    border: 1px solid rgba(91, 101, 132, 0.5) !important;
    border-radius: 10px !important;
    overflow: hidden !important;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04) !important;
  }

  /deep/ .twolist-top {
    height: 94px !important;
    display: grid !important;
    place-items: center !important;
  }

  /deep/ .twolist-top img {
    width: 118px !important;
    height: 88px !important;
    object-fit: contain !important;
    filter: drop-shadow(0 16px 18px rgba(0, 0, 0, 0.46)) !important;
  }

  /deep/ .twolist-bot,
  /deep/ .threelist-name {
    height: 34px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 5px !important;
    background: rgba(18, 21, 31, 0.38) !important;
  }

  /deep/ .twolist-bot img,
  /deep/ .threelist-name img {
    width: 14px !important;
    height: 14px !important;
    content: url("../assets/pizzaking/pizza-token.svg") !important;
  }

  /deep/ .twolist-bot span,
  /deep/ .threelist-name span {
    margin: 0 !important;
    color: #ffd76a !important;
    font-size: 13px !important;
    font-weight: 900 !important;
  }

  /deep/ .twolist-num {
    inset: 0 !important;
    display: flex !important;
    align-items: flex-start !important;
    justify-content: flex-end !important;
    padding: 9px !important;
    color: #fff !important;
    background:
      linear-gradient(180deg, rgba(255, 122, 0, 0.1), rgba(255, 122, 0, 0.24)) !important;
    border: 1px solid #ff7a00 !important;
    border-radius: 10px !important;
    box-shadow:
      inset 0 0 0 1px rgba(255, 202, 128, 0.18),
      0 0 22px rgba(255, 122, 0, 0.22) !important;
    font-size: 14px !important;
    font-weight: 900 !important;
  }

  /deep/ .sty-three {
    flex: 0 0 auto !important;
    border-bottom: 0 !important;
    background:
      linear-gradient(180deg, rgba(39, 42, 57, 0.95), rgba(24, 26, 38, 0.96)) !important;
  }

  /deep/ .sty-three-hint {
    margin-bottom: 12px !important;
  }

  /deep/ .sty-three-hint span {
    color: #8d97ad !important;
    font-size: 13px !important;
    font-weight: 900 !important;
  }

  /deep/ .sty-three-hint strong {
    color: #ffd76a !important;
    font-weight: 900 !important;
  }

  /deep/ .sty-three-list ul {
    margin: 0 !important;
    display: grid !important;
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
    gap: 7px !important;
  }

  /deep/ .sty-three-list ul li {
    width: auto !important;
  }

  /deep/ .threelist-warp {
    height: 58px !important;
    margin: 0 !important;
    display: grid !important;
    place-items: center !important;
    background: #202331 !important;
    border: 1px solid rgba(88, 98, 128, 0.5) !important;
    border-radius: 8px !important;
    overflow: hidden !important;
  }

  /deep/ .threelist-img img {
    width: 48px !important;
    height: 35px !important;
    object-fit: contain !important;
  }

  /deep/ .threelist-name {
    display: none !important;
  }

  /deep/ .sty-three-btn1 {
    margin-top: 16px !important;
  }

  /deep/ .sty-three-btn {
    width: 100% !important;
    height: 48px !important;
    margin: 0 !important;
    padding: 0 !important;
    color: #fff !important;
    background: linear-gradient(180deg, #ff9a1b, #ff6f00) !important;
    border: 1px solid rgba(255, 185, 84, 0.5) !important;
    border-radius: 8px !important;
    box-shadow: 0 16px 30px rgba(255, 122, 0, 0.28) !important;
    font-size: 15px !important;
    font-weight: 900 !important;
  }
}

@media screen and (max-width: 1024px) {
  .pk-lucky-content {
    width: 100%;
    margin-left: 0;
  }

  .pk-lucky-content::before {
    left: 0;
  }

  .pk-lucky-page .lucky-warp {
    max-width: none;
  }

  .pk-lucky-page .room .room-box .room-box-ul {
    grid-template-columns: 1fr !important;
  }

  .pk-battle-preview-cases {
    grid-template-columns: repeat(3, minmax(120px, 1fr));
  }
}
</style>

<style lang="less">
/* 2026-07-25 desktop battle parity: the target page starts directly with a compact toolbar and room grid. */
@media screen and (min-width: 981px) {
  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp {
    padding: 16px 20px 88px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top {
    height: 66px !important;
    min-height: 66px !important;
    margin: 0 0 20px !important;
    padding: 0 14px !important;
    background: transparent !important;
    border-bottom: 1px solid rgba(86, 93, 118, 0.34) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .top .left {
    width: auto !important;
    min-width: 0 !important;
    flex: 0 0 auto !important;
    height: 66px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .top .left::before {
    content: "箱子战斗" !important;
    color: #f4ead8 !important;
    font-size: 20px !important;
    line-height: 66px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .top .left::after {
    display: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span1 {
    height: 34px !important;
    padding: 0 14px !important;
    line-height: 34px !important;
    background: #252836 !important;
    border-color: rgba(88, 98, 126, 0.6) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort {
    height: 34px !important;
    padding: 0 12px !important;
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort span {
    line-height: 34px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span2 {
    min-width: 116px !important;
    height: 38px !important;
    line-height: 38px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .luc-list,
  body:has(.pk-lucky-page) .pk-lucky-page .hint {
    display: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room,
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
    margin: 0 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 24px 20px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li,
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail {
    height: 171px !important;
    min-height: 171px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
    background: linear-gradient(90deg, #202331 0 65%, #1d202d 65% 100%) !important;
    border-color: rgba(64, 70, 92, 0.88) !important;
    border-bottom-color: rgba(242, 105, 0, 0.72) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .three {
    width: 65% !important;
    height: 171px !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail img {
    height: 134px !important;
    max-width: 92% !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .two {
    left: 65% !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .roombox-warp .one.two1,
  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .roombox-warp .one.two2,
  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .roombox-warp .one.two3,
  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .roombox-warp .one {
    position: absolute !important;
    left: 65% !important;
    right: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    width: auto !important;
    height: 171px !important;
    display: block !important;
    z-index: 4 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .roombox-warp .status-condiv {
    left: auto !important;
    right: 20px !important;
    top: 22px !important;
    width: auto !important;
    text-align: right !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
    left: calc(65% + 22px) !important;
    right: auto !important;
    top: 24px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
    left: 22px !important;
    top: 76px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
    right: 22px !important;
    top: 68px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .room-box .room-box-ul > li.bg_1 .roombox-warp::after,
  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .roombox-warp::after,
  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .roombox-warp::after,
  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
    top: auto !important;
    right: 22px !important;
    bottom: 20px !important;
    left: auto !important;
    min-width: 110px !important;
    height: 38px !important;
    line-height: 38px !important;
    transform: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .roombox-warp .one {
    display: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .room-box .room-box-ul > li.bg_1 .roombox-warp .one.two1,
  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .roombox-warp .one.two3,
  body:has(.pk-lucky-page) .pk-lucky-page.pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .roombox-warp .one.two2 {
    display: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-battle-info-panel {
    position: absolute !important;
    left: 65% !important;
    right: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    z-index: 9 !important;
    color: #dfe5f4 !important;
    font-weight: 900 !important;
    pointer-events: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .pk-battle-info-panel .pk-battle-player {
    position: absolute !important;
    right: 20px !important;
    top: 22px !important;
    color: #dfe5f4 !important;
    font-size: 14px !important;
    line-height: 18px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .pk-battle-info-panel .pk-battle-state {
    position: absolute !important;
    left: 22px !important;
    top: 48px !important;
    color: #f3bd4c !important;
    font-size: 13px !important;
    line-height: 18px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .pk-battle-info-panel .pk-battle-rounds {
    position: absolute !important;
    left: 22px !important;
    top: 78px !important;
    color: #aab7c8 !important;
    font-size: 13px !important;
    line-height: 18px !important;
  }
}
</style>

<style lang="less">
/* 2026-07-05 exact-pass: battle list card geometry and target glow. */
body:has(.pk-lucky-page) .pk-lucky-page {
  background:
    radial-gradient(ellipse at 50% 120px, rgba(253, 107, 1, 0.08), transparent 440px),
    #191b26 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
  gap: 8px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li {
  min-height: 222px !important;
  border-radius: 8px !important;
  background: #20222f !important;
  border: 1px solid rgba(236, 216, 184, 0.08) !important;
  box-shadow: none !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_1 {
  border-color: rgba(253, 107, 1, 0.75) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 {
  border-color: rgba(1, 253, 5, 0.48) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp::before {
  content: "" !important;
  position: absolute !important;
  inset: 0 !important;
  pointer-events: none !important;
  background:
    radial-gradient(ellipse at 50% 82%, rgba(253, 107, 1, 0.14), transparent 42%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.02), transparent 50%) !important;
  z-index: 1 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .roombox-warp::before {
  background:
    radial-gradient(ellipse at 50% 82%, rgba(1, 253, 5, 0.12), transparent 42%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.02), transparent 50%) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  content: "观看  ○" !important;
  z-index: 12 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .roll-list {
  position: relative !important;
  z-index: 3 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .roll-list li {
  background: rgba(255, 255, 255, 0.015) !important;
  border-right: 1px solid rgba(236, 216, 184, 0.08) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .roll-list img {
  filter:
    drop-shadow(0 16px 18px rgba(0, 0, 0, 0.38))
    drop-shadow(0 0 20px rgba(253, 107, 1, 0.14)) !important;
}
</style>

<style lang="less">
/* 2026-07-03 battle list final pvp-short shell: target horizontal flow wins last. */
body:has(.pk-lucky-page) .pk-lucky-page .room {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  height: 157px !important;
  margin: 28px 0 0 !important;
  padding: 0 !important;
  background: #1c1d29 !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room::after {
  content: "" !important;
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
  z-index: 12 !important;
  width: 200px !important;
  height: 157px !important;
  pointer-events: none !important;
  background: linear-gradient(270deg, #1c1d29, rgba(28, 29, 41, 0)) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room > .clear {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .luc-list,
body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-preview-cases,
body:has(.pk-lucky-page) .pk-lucky-page .hint {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp {
  padding-top: 24px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top {
  height: 54px !important;
  min-height: 54px !important;
  margin-bottom: 18px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 18px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .left {
  color: #f5f5f5 !important;
  font-size: 28px !important;
  line-height: 100% !important;
  font-weight: 800 !important;
  letter-spacing: -0.4px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .right {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 10px !important;
  flex-wrap: nowrap !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span,
body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort span {
  height: 38px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
  padding: 0 16px !important;
  border-radius: 8px !important;
  background: #232531 !important;
  border: 1px solid rgba(236, 216, 184, 0.12) !important;
  color: rgba(240, 248, 255, 0.72) !important;
  font-size: 13px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  margin: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span2 {
  min-width: 112px !important;
  border-color: #f28a1a !important;
  background: linear-gradient(180deg, #ff9d00 0%, #ff6f00 100%) !important;
  color: #fff7df !important;
  box-shadow: 0 0 18px rgba(255, 122, 0, 0.32) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title {
  width: 92px !important;
  height: 157px !important;
  flex: 0 0 92px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #1c1d29 !important;
  z-index: 13 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title span {
  margin-top: 10px !important;
  color: #ecd8b8 !important;
  font-size: 16px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
  writing-mode: vertical-rl !important;
  transform: rotate(180deg) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
  min-width: 0 !important;
  width: auto !important;
  flex: 1 1 auto !important;
  margin: 0 !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
  width: max-content !important;
  display: flex !important;
  align-items: center !important;
  grid-template-columns: none !important;
  gap: 10px !important;
  overflow: visible !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  width: 394px !important;
  min-width: 394px !important;
  max-width: 394px !important;
  flex: 0 0 394px !important;
  height: 137px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  content: "观看  ○" !important;
  top: 18px !important;
  right: 50% !important;
  bottom: auto !important;
  transform: translateX(50%) !important;
  height: 32px !important;
  min-width: 92px !important;
  padding: 0 18px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 6px !important;
  background: transparent !important;
  color: #ecd8b8 !important;
  font-size: 14px !important;
  line-height: 32px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  text-transform: uppercase !important;
  box-shadow: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp:hover::after {
  background: rgba(236, 216, 184, 0.1) !important;
}
</style>

<style lang="less">
/* 2026-07-03 battle list pvp-short shell: match target left vertical title and horizontal card flow. */
body:has(.pk-lucky-page) .pk-lucky-page .room {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  height: 157px !important;
  margin: 28px 0 0 !important;
  padding: 0 !important;
  background: #1c1d29 !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room::after {
  content: "" !important;
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
  z-index: 12 !important;
  width: 200px !important;
  height: 157px !important;
  pointer-events: none !important;
  background: linear-gradient(270deg, #1c1d29, rgba(28, 29, 41, 0)) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room > .clear {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title {
  width: 92px !important;
  height: 157px !important;
  flex: 0 0 92px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #1c1d29 !important;
  z-index: 13 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title span {
  margin-top: 10px !important;
  color: #ecd8b8 !important;
  font-size: 16px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
  writing-mode: vertical-rl !important;
  transform: rotate(180deg) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
  min-width: 0 !important;
  width: auto !important;
  flex: 1 1 auto !important;
  margin: 0 !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
  width: max-content !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  overflow: visible !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  width: 394px !important;
  min-width: 394px !important;
  max-width: 394px !important;
  flex: 0 0 394px !important;
  height: 137px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  content: "观看  ○" !important;
  top: 18px !important;
  right: 50% !important;
  transform: translateX(50%) !important;
  height: 32px !important;
  min-width: 92px !important;
  padding: 0 18px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 6px !important;
  background: transparent !important;
  color: #ecd8b8 !important;
  font-size: 14px !important;
  line-height: 32px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  box-shadow: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp:hover::after {
  background: rgba(236, 216, 184, 0.1) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .more-btn {
  display: none !important;
}
</style>

<style lang="less">
/* 2026-07-03 battle list target metrics: match HotPizza pvp-short card scale. */
body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
  grid-template-columns: repeat(auto-fill, minmax(394px, 1fr)) !important;
  gap: 10px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  height: 137px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  height: 137px !important;
  border: 0 !important;
  border-radius: 10px !important;
  background: transparent !important;
  box-shadow: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::before {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .one {
  height: 66px !important;
  border-radius: 10px 10px 0 0 !important;
  background:
    radial-gradient(100% 50% at 50% 0, rgba(236, 216, 184, 0.1) 0, rgba(39, 42, 54, 0) 100%),
    linear-gradient(180deg, #21232f, #282a35) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .three {
  top: 66px !important;
  width: 100% !important;
  height: 70px !important;
  grid-template-columns: repeat(4, minmax(78px, 1fr)) !important;
  border-radius: 0 0 10px 10px !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail {
  height: 70px !important;
  border-bottom: 1px solid #ecd8b8 !important;
  background: linear-gradient(180deg, rgba(40, 42, 53, 0), rgba(236, 216, 184, 0.2)), #282a35 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail img {
  height: 58px !important;
  width: auto !important;
  max-width: 92% !important;
  margin: 8px auto 0 !important;
  display: block !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail .box-num {
  left: 5px !important;
  top: 5px !important;
  color: #ecd8b8 !important;
  font-size: 10px !important;
  line-height: 100% !important;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
  left: auto !important;
  right: 20px !important;
  top: 14px !important;
  height: 18px !important;
  font-size: 14px !important;
  z-index: 8 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top span {
  color: #edb145 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  font-weight: 700 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top img {
  width: 14px !important;
  height: 14px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv {
  left: 20px !important;
  top: 14px !important;
  right: auto !important;
  height: 38px !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  color: rgba(240, 248, 255, 0.8) !important;
  font-size: 12px !important;
  line-height: 100% !important;
  z-index: 8 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-label {
  color: rgba(240, 248, 255, 0.8) !important;
  font-size: 12px !important;
  line-height: 100% !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-value,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-count {
  color: rgba(240, 248, 255, 0.8) !important;
  font-size: 12px !important;
  line-height: 100% !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
  right: 20px !important;
  left: auto !important;
  top: 38px !important;
  color: rgba(240, 248, 255, 0.8) !important;
  font-size: 12px !important;
  line-height: 100% !important;
  text-align: right !important;
  z-index: 8 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
  left: 20px !important;
  top: 36px !important;
  max-width: 154px !important;
  height: 22px !important;
  gap: 3px !important;
  z-index: 9 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-tou,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-tou img,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-true {
  width: 16px !important;
  height: 16px !important;
  border-radius: 16px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-false {
  width: 16px !important;
  height: 16px !important;
  border-radius: 16px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .vs {
  width: 20px !important;
  height: 20px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  top: 18px !important;
  right: 50% !important;
  bottom: auto !important;
  transform: translateX(50%) !important;
  min-width: auto !important;
  width: auto !important;
  height: 32px !important;
  padding: 8px 20px !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 6px !important;
  background: transparent !important;
  color: #ecd8b8 !important;
  font-size: 14px !important;
  line-height: 100% !important;
  text-transform: uppercase !important;
}

@media screen and (max-width: 980px) {
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    grid-template-columns: 1fr !important;
  }
}

/* battle strip final alignment: keep Chinese upright and reserve fixed header zones */
body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title span {
  writing-mode: vertical-rl !important;
  text-orientation: upright !important;
  transform: none !important;
  letter-spacing: 5px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
  position: relative !important;
  padding-right: 18px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box::after {
  content: "" !important;
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
  z-index: 11 !important;
  width: 52px !important;
  height: 100% !important;
  pointer-events: none !important;
  background: linear-gradient(270deg, #1c1d29 12%, rgba(28, 29, 41, 0)) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .one {
  position: relative !important;
  display: grid !important;
  grid-template-columns: minmax(112px, 1fr) 126px minmax(92px, 1fr) !important;
  align-items: center !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv {
  position: relative !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  align-self: stretch !important;
  padding: 13px 0 0 20px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
  left: 20px !important;
  top: 37px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  left: 50% !important;
  right: auto !important;
  top: 50% !important;
  bottom: auto !important;
  transform: translate(-50%, -50%) !important;
  box-sizing: border-box !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
  position: relative !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  justify-self: end !important;
  align-self: start !important;
  padding: 13px 20px 0 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
  left: auto !important;
  right: 20px !important;
  top: 37px !important;
  bottom: auto !important;
  min-width: 70px !important;
  justify-content: flex-end !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top::before {
  flex: 0 0 4px !important;
  margin-right: 4px !important;
}

@media screen and (max-width: 1280px) {
  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
    width: 360px !important;
    min-width: 360px !important;
    max-width: 360px !important;
    flex-basis: 360px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .one {
    grid-template-columns: minmax(96px, 1fr) 112px minmax(82px, 1fr) !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 create battle drawer real final: appended after battle final metrics. */
.el-drawer__wrapper.sty .el-drawer.rtl {
  width: 760px !important;
  max-width: 100vw !important;
  background:
    radial-gradient(circle at 85% 0, rgba(237, 177, 69, 0.16), transparent 34%),
    linear-gradient(180deg, #242631 0%, #1c1d29 100%) !important;
  border-left: 1px solid rgba(236, 216, 184, 0.18) !important;
  box-shadow: -34px 0 90px rgba(0, 0, 0, 0.56) !important;
}

.el-drawer__wrapper.sty .sty-warp {
  padding: 28px 30px !important;
  gap: 20px !important;
  background: transparent !important;
}

.el-drawer__wrapper.sty .sty-warp::before {
  content: "创建战斗" !important;
  height: 44px !important;
  color: #f5f5f5 !important;
  font-size: 30px !important;
  line-height: 100% !important;
  font-weight: 800 !important;
  letter-spacing: -0.4px !important;
}

.el-drawer__wrapper.sty .sty-one,
.el-drawer__wrapper.sty .sty-two,
.el-drawer__wrapper.sty .sty-three {
  border: 1px solid rgba(236, 216, 184, 0.12) !important;
  border-radius: 12px !important;
  background: rgba(35, 37, 49, 0.74) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
}

.el-drawer__wrapper.sty .sty-one,
.el-drawer__wrapper.sty .sty-two,
.el-drawer__wrapper.sty .sty-three {
  padding: 16px !important;
}

.el-drawer__wrapper.sty .sty-one-pattern {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 10px !important;
}

.el-drawer__wrapper.sty .sty-one-pattern span {
  width: auto !important;
  height: 42px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 8px !important;
  background: rgba(236, 216, 184, 0.1) !important;
  color: #ecd8b8 !important;
  font-size: 14px !important;
  font-weight: 800 !important;
}

.el-drawer__wrapper.sty .sty-one-pattern span.span1 {
  border-color: rgba(236, 216, 184, 0.12) !important;
  background: #1f212d !important;
  color: rgba(240, 248, 255, 0.72) !important;
}

.el-drawer__wrapper.sty .sty-two-list {
  margin-top: 12px !important;
}

.el-drawer__wrapper.sty .sty-two-list ul {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  gap: 10px !important;
}

.el-drawer__wrapper.sty .twolist-warp {
  height: 132px !important;
  border: 1px solid rgba(236, 216, 184, 0.1) !important;
  border-radius: 10px !important;
  background: linear-gradient(180deg, rgba(40, 42, 53, 0), rgba(236, 216, 184, 0.08)), #282a35 !important;
  overflow: hidden !important;
}

.el-drawer__wrapper.sty .twolist-top {
  height: 88px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.el-drawer__wrapper.sty .twolist-top img {
  max-width: 92% !important;
  max-height: 78px !important;
  object-fit: contain !important;
}

.el-drawer__wrapper.sty .twolist-bot {
  height: 34px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  color: #edb145 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
}

.el-drawer__wrapper.sty .twolist-bot img {
  width: 13px !important;
  height: 13px !important;
}

.el-drawer__wrapper.sty .twolist-num,
.el-drawer__wrapper.sty .twolist-num1 {
  right: 8px !important;
  top: 8px !important;
  min-width: 24px !important;
  height: 20px !important;
  border-radius: 10px !important;
  background: rgba(237, 177, 69, 0.16) !important;
  color: #ecd8b8 !important;
  font-size: 12px !important;
  line-height: 20px !important;
}

.el-drawer__wrapper.sty .sty-three-list ul {
  display: grid !important;
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  gap: 8px !important;
}

.el-drawer__wrapper.sty .sty-three-list ul li {
  width: auto !important;
  margin: 0 !important;
}

.el-drawer__wrapper.sty .threelist-warp {
  height: 78px !important;
  border: 1px dashed rgba(236, 216, 184, 0.22) !important;
  border-radius: 8px !important;
  background: #1f212d !important;
}

.el-drawer__wrapper.sty .threelist-img img {
  max-height: 48px !important;
  object-fit: contain !important;
}

.el-drawer__wrapper.sty .sty-three-btn1 {
  margin-top: 14px !important;
}

.el-drawer__wrapper.sty .sty-three-btn {
  width: 100% !important;
  height: 46px !important;
  border: 0 !important;
  border-radius: 8px !important;
  background: linear-gradient(180deg, #ff9d00 0%, #ff6f00 100%) !important;
  box-shadow: 0 0 22px rgba(255, 122, 0, 0.28) !important;
  color: transparent !important;
  font-size: 0 !important;
  font-weight: 900 !important;
}

.el-drawer__wrapper.sty .sty-three-btn::after {
  content: "创建战斗" !important;
  color: #fff7df !important;
  font-size: 16px !important;
  line-height: 46px !important;
}
</style>

<style lang="less">
/* 2026-07-03 create battle drawer target pass: dark HotPizza visual system. */
.el-drawer__wrapper.sty .el-drawer.rtl {
  width: 760px !important;
  max-width: 100vw !important;
  background:
    radial-gradient(circle at 85% 0, rgba(237, 177, 69, 0.16), transparent 34%),
    linear-gradient(180deg, #242631 0%, #1c1d29 100%) !important;
  border-left: 1px solid rgba(236, 216, 184, 0.18) !important;
  box-shadow: -34px 0 90px rgba(0, 0, 0, 0.56) !important;
}

.el-drawer__wrapper.sty .sty-warp {
  padding: 28px 30px !important;
  gap: 20px !important;
  background: transparent !important;
}

.el-drawer__wrapper.sty .sty-warp::before {
  content: "创建战斗" !important;
  height: 44px !important;
  color: #f5f5f5 !important;
  font-size: 30px !important;
  line-height: 100% !important;
  font-weight: 800 !important;
  letter-spacing: -0.4px !important;
}

.el-drawer__wrapper.sty .sty-one,
.el-drawer__wrapper.sty .sty-two,
.el-drawer__wrapper.sty .sty-three {
  border: 1px solid rgba(236, 216, 184, 0.12) !important;
  border-radius: 12px !important;
  background: rgba(35, 37, 49, 0.74) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
}

.el-drawer__wrapper.sty .sty-one {
  padding: 16px !important;
}

.el-drawer__wrapper.sty .sty-one-pattern {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 10px !important;
}

.el-drawer__wrapper.sty .sty-one-pattern span {
  width: auto !important;
  height: 42px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 8px !important;
  background: rgba(236, 216, 184, 0.1) !important;
  color: #ecd8b8 !important;
  font-size: 14px !important;
  font-weight: 800 !important;
}

.el-drawer__wrapper.sty .sty-one-pattern span.span1 {
  border-color: rgba(236, 216, 184, 0.12) !important;
  background: #1f212d !important;
  color: rgba(240, 248, 255, 0.72) !important;
}

.el-drawer__wrapper.sty .sty-two {
  padding: 16px !important;
}

.el-drawer__wrapper.sty .sty-two-list {
  margin-top: 12px !important;
}

.el-drawer__wrapper.sty .sty-two-list ul {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  gap: 10px !important;
}

.el-drawer__wrapper.sty .twolist-warp {
  height: 132px !important;
  border: 1px solid rgba(236, 216, 184, 0.1) !important;
  border-radius: 10px !important;
  background: linear-gradient(180deg, rgba(40, 42, 53, 0), rgba(236, 216, 184, 0.08)), #282a35 !important;
  overflow: hidden !important;
}

.el-drawer__wrapper.sty .twolist-top {
  height: 88px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.el-drawer__wrapper.sty .twolist-top img {
  max-width: 92% !important;
  max-height: 78px !important;
  object-fit: contain !important;
}

.el-drawer__wrapper.sty .twolist-bot {
  height: 34px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  color: #edb145 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
}

.el-drawer__wrapper.sty .twolist-bot img {
  width: 13px !important;
  height: 13px !important;
}

.el-drawer__wrapper.sty .twolist-num,
.el-drawer__wrapper.sty .twolist-num1 {
  right: 8px !important;
  top: 8px !important;
  min-width: 24px !important;
  height: 20px !important;
  border-radius: 10px !important;
  background: rgba(237, 177, 69, 0.16) !important;
  color: #ecd8b8 !important;
  font-size: 12px !important;
  line-height: 20px !important;
}

.el-drawer__wrapper.sty .sty-three {
  padding: 14px 16px 16px !important;
}

.el-drawer__wrapper.sty .sty-three-list ul {
  display: grid !important;
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  gap: 8px !important;
}

.el-drawer__wrapper.sty .sty-three-list ul li {
  width: auto !important;
  margin: 0 !important;
}

.el-drawer__wrapper.sty .threelist-warp {
  height: 78px !important;
  border: 1px dashed rgba(236, 216, 184, 0.22) !important;
  border-radius: 8px !important;
  background: #1f212d !important;
}

.el-drawer__wrapper.sty .threelist-img img {
  max-height: 48px !important;
  object-fit: contain !important;
}

.el-drawer__wrapper.sty .sty-three-btn1 {
  margin-top: 14px !important;
}

.el-drawer__wrapper.sty .sty-three-btn {
  width: 100% !important;
  height: 46px !important;
  border: 0 !important;
  border-radius: 8px !important;
  background: linear-gradient(180deg, #ff9d00 0%, #ff6f00 100%) !important;
  box-shadow: 0 0 22px rgba(255, 122, 0, 0.28) !important;
  color: transparent !important;
  font-size: 0 !important;
  font-weight: 900 !important;
}

.el-drawer__wrapper.sty .sty-three-btn::after {
  content: "创建战斗" !important;
  color: #fff7df !important;
  font-size: 16px !important;
  line-height: 46px !important;
}
</style>

<style lang="less">
/* 2026-07-03 battle list real final pvp-short shell: appended after target metrics. */
body:has(.pk-lucky-page) .pk-lucky-page .room {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  height: 157px !important;
  margin: 28px 0 0 !important;
  padding: 0 !important;
  background: #1c1d29 !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room::after {
  content: "" !important;
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
  z-index: 12 !important;
  width: 200px !important;
  height: 157px !important;
  pointer-events: none !important;
  background: linear-gradient(270deg, #1c1d29, rgba(28, 29, 41, 0)) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room > .clear {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title {
  width: 92px !important;
  height: 157px !important;
  flex: 0 0 92px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #1c1d29 !important;
  z-index: 13 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title span {
  margin-top: 10px !important;
  color: #ecd8b8 !important;
  font-size: 16px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
  writing-mode: vertical-rl !important;
  transform: rotate(180deg) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
  min-width: 0 !important;
  width: auto !important;
  flex: 1 1 auto !important;
  margin: 0 !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
  width: max-content !important;
  display: flex !important;
  align-items: center !important;
  grid-template-columns: none !important;
  gap: 10px !important;
  overflow: visible !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  width: 394px !important;
  min-width: 394px !important;
  max-width: 394px !important;
  flex: 0 0 394px !important;
  height: 137px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  content: "观看  ○" !important;
  top: 18px !important;
  right: 50% !important;
  bottom: auto !important;
  transform: translateX(50%) !important;
  height: 32px !important;
  min-width: 92px !important;
  padding: 0 18px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 6px !important;
  background: transparent !important;
  color: #ecd8b8 !important;
  font-size: 14px !important;
  line-height: 32px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  text-transform: uppercase !important;
  box-shadow: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp:hover::after {
  background: rgba(236, 216, 184, 0.1) !important;
}

@media screen and (max-width: 980px) {
  body:has(.pk-lucky-page) .pk-lucky-page .room {
    height: auto !important;
    min-height: 157px !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 battle list target correction: HotPizza-like single wide rows. */
body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp > .room > .ranking {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room {
  width: 100% !important;
  display: block !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
  width: 100% !important;
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 18px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  width: 100% !important;
  height: 222px !important;
  margin: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  height: 222px !important;
  border: 1px solid rgba(67, 75, 102, 0.92) !important;
  border-bottom-color: rgba(255, 122, 0, 0.78) !important;
  border-radius: 13px !important;
  background:
    linear-gradient(90deg, rgba(38, 41, 55, 0.94) 0 72%, rgba(30, 33, 47, 0.98) 72% 100%),
    #202230 !important;
  box-shadow: 0 18px 46px rgba(0, 0, 0, 0.22) !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::before {
  content: "" !important;
  left: 22px !important;
  top: 22px !important;
  width: 7px !important;
  height: 7px !important;
  background: #ff7a00 !important;
  border-radius: 50% !important;
  box-shadow: 0 0 13px rgba(255, 122, 0, 0.88) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  content: "\89c2\770b\6218\6597" !important;
  right: 42px !important;
  bottom: 26px !important;
  min-width: 152px !important;
  height: 44px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #fff7df !important;
  font-size: 16px !important;
  font-weight: 1000 !important;
  border-radius: 7px !important;
  border: 1px solid rgba(255, 232, 188, 0.76) !important;
  background: rgba(36, 39, 53, 0.72) !important;
  box-shadow: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .one,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .two,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-img {
  background: transparent !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .three {
  left: 0 !important;
  top: 0 !important;
  width: 72% !important;
  height: 222px !important;
  display: grid !important;
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  gap: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail {
  width: auto !important;
  height: 222px !important;
  min-width: 0 !important;
  border-radius: 0 !important;
  border-right: 1px solid rgba(17, 19, 30, 0.62) !important;
  background:
    radial-gradient(circle at 50% 48%, rgba(255, 122, 0, 0.16), transparent 56%),
    linear-gradient(180deg, rgba(46, 50, 65, 0.64), rgba(35, 38, 52, 0.78)) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail::before {
  opacity: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail img {
  width: 92% !important;
  height: 168px !important;
  margin-top: 28px !important;
  object-fit: contain !important;
  filter: drop-shadow(0 18px 24px rgba(0, 0, 0, 0.32)) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail .box-num {
  left: 24px !important;
  top: 28px !important;
  color: #aeb7c8 !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
  left: calc(72% + 38px) !important;
  top: 30px !important;
  width: auto !important;
  height: 30px !important;
  display: flex !important;
  align-items: center !important;
  gap: 7px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top span {
  color: #ffbc35 !important;
  font-size: 20px !important;
  line-height: 30px !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv {
  left: calc(72% + 38px) !important;
  right: 40px !important;
  top: 76px !important;
  height: 30px !important;
  width: auto !important;
  display: flex !important;
  align-items: center !important;
  gap: 7px !important;
  text-align: left !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv::after {
  content: none !important;
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .point {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-label {
  color: #aeb7c8 !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-value,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-count {
  color: #f5f7ff !important;
  font-size: 19px !important;
  line-height: 28px !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
  left: calc(72% + 38px) !important;
  top: 118px !important;
  width: auto !important;
  color: #aeb7c8 !important;
  font-size: 15px !important;
  line-height: 28px !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count::before {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
  left: calc(72% + 38px) !important;
  top: 158px !important;
  max-width: calc(28% - 78px) !important;
  height: 38px !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-tou,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-tou img,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-true {
  width: 34px !important;
  height: 34px !important;
  border-radius: 50% !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-false {
  width: 18px !important;
  height: 18px !important;
}

@media screen and (max-width: 1180px) {
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .three {
    width: 62% !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
    left: calc(62% + 22px) !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 battle list status polish: waiting/running/finished visual states. */
body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_1 .roombox-warp {
  border-color: rgba(255, 132, 31, 0.64) !important;
  background:
    radial-gradient(circle at 25% 50%, rgba(255, 132, 31, 0.16), transparent 34%),
    linear-gradient(180deg, #282b3a, #202230) !important;
  box-shadow:
    inset 0 0 0 1px rgba(255, 224, 170, 0.08),
    0 0 30px rgba(255, 132, 31, 0.1) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .roombox-warp {
  border-color: rgba(28, 214, 230, 0.58) !important;
  background:
    radial-gradient(circle at 25% 50%, rgba(28, 214, 230, 0.13), transparent 34%),
    linear-gradient(180deg, #272a39, #202230) !important;
  box-shadow:
    inset 0 0 0 1px rgba(140, 244, 255, 0.07),
    0 0 30px rgba(28, 214, 230, 0.08) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .roombox-warp {
  border-color: rgba(111, 121, 151, 0.44) !important;
  background:
    radial-gradient(circle at 25% 50%, rgba(111, 121, 151, 0.12), transparent 34%),
    linear-gradient(180deg, #252836, #1e202c) !important;
  opacity: 0.92 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_1 .roombox-warp::before,
body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .roombox-warp::before,
body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .roombox-warp::before {
  position: absolute !important;
  left: 18px !important;
  top: 18px !important;
  z-index: 6 !important;
  width: 8px !important;
  height: 8px !important;
  border-radius: 50% !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_1 .roombox-warp::before {
  background: #ff8a00 !important;
  box-shadow: 0 0 14px rgba(255, 138, 0, 0.8) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .roombox-warp::before {
  background: #16d7e8 !important;
  box-shadow: 0 0 14px rgba(22, 215, 232, 0.78) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .roombox-warp::before {
  background: #7f889b !important;
  box-shadow: 0 0 14px rgba(127, 136, 155, 0.48) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  height: 42px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 7px !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
  letter-spacing: 0.2px !important;
  color: #fff7df !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_1 .roombox-warp::after {
  content: "\52a0\5165\5bf9\6218" !important;
  background: linear-gradient(180deg, #ff9a18, #f26900) !important;
  border: 1px solid rgba(255, 214, 128, 0.34) !important;
  box-shadow: 0 12px 24px rgba(242, 105, 0, 0.28) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .roombox-warp::after {
  content: "\89c2\770b" !important;
  background: rgba(31, 36, 52, 0.86) !important;
  border: 1px solid rgba(28, 214, 230, 0.42) !important;
  box-shadow: 0 0 24px rgba(28, 214, 230, 0.12) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .roombox-warp::after {
  content: "\67e5\770b\7ed3\679c" !important;
  background: rgba(31, 36, 52, 0.72) !important;
  border: 1px solid rgba(111, 121, 151, 0.34) !important;
  color: #c9d1e2 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_1 .status-condiv::after,
body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .status-condiv::after,
body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .status-condiv::after {
  display: block !important;
  margin-top: 5px !important;
  font-size: 13px !important;
  line-height: 18px !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_1 .status-condiv::after {
  content: "\7b49\5f85\4e2d" !important;
  color: #ff9a18 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .status-condiv::after {
  content: "\8fdb\884c\4e2d" !important;
  color: #16d7e8 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .status-condiv::after {
  content: "\5df2\7ed3\675f" !important;
  color: #aeb7c8 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .box-detail {
  filter: grayscale(0.18) brightness(0.86) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .two-top span {
  color: #c9d1e2 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .box-detail::before {
  background:
    radial-gradient(circle at 50% 50%, rgba(28, 214, 230, 0.16), transparent 60%) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_1 .box-detail::before {
  background:
    radial-gradient(circle at 50% 50%, rgba(255, 132, 31, 0.18), transparent 60%) !important;
}
</style>

<style lang="less">
/* 2026-07-03 create battle drawer parity pass. */
.sty .el-drawer.rtl {
  width: 620px !important;
  max-width: 100vw !important;
  background:
    radial-gradient(circle at 80% 0, rgba(255, 156, 31, 0.16), transparent 38%),
    radial-gradient(circle at 20% 18%, rgba(35, 226, 246, 0.08), transparent 34%),
    linear-gradient(180deg, #242736 0%, #1b1d29 100%) !important;
  border-left: 1px solid rgba(111, 121, 151, 0.28) !important;
  box-shadow: -28px 0 70px rgba(0, 0, 0, 0.48) !important;
}

.sty .el-drawer__body {
  height: 100% !important;
  padding: 0 !important;
  overflow: hidden !important;
}

.sty .sty-warp {
  height: 100% !important;
  padding: 24px !important;
  display: grid !important;
  grid-template-rows: auto minmax(0, 1fr) auto !important;
  gap: 18px !important;
  color: #f5f7ff !important;
}

.sty .sty-warp::before {
  content: "创建战斗" !important;
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
  color: #f7efe0 !important;
  font-size: 28px !important;
  line-height: 34px !important;
  font-weight: 1000 !important;
  text-shadow: 0 0 24px rgba(255, 194, 92, 0.18) !important;
}

.sty .sty-one,
.sty .sty-two,
.sty .sty-three {
  margin: 0 !important;
  padding: 16px !important;
  border: 1px solid rgba(111, 121, 151, 0.24) !important;
  border-radius: 12px !important;
  background:
    linear-gradient(180deg, rgba(43, 46, 62, 0.96), rgba(33, 35, 49, 0.96)) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
}

.sty .sty-one-hint,
.sty .sty-two-hint1 {
  margin: 0 0 12px !important;
  color: transparent !important;
  font-size: 0 !important;
}

.sty .sty-one-hint::after {
  content: "选择玩家模式" !important;
  color: #f5f7ff !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
}

.sty .sty-two-hint1::after {
  content: "选择盲盒" !important;
  color: #f5f7ff !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
}

.sty .sty-two-hint2 {
  margin: -6px 0 12px !important;
  color: transparent !important;
  font-size: 0 !important;
}

.sty .sty-two-hint2::after {
  content: "最多选择 6 个盲盒，点击箱子添加，再点击下方已选箱子移除" !important;
  color: #8f98ab !important;
  font-size: 12px !important;
  line-height: 18px !important;
  font-weight: 800 !important;
}

.sty .sty-one-pattern {
  display: grid !important;
  grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  gap: 10px !important;
}

.sty .sty-one-pattern span {
  height: 46px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #fff2d1 !important;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 194, 92, 0.18), transparent 52%),
    #303344 !important;
  border: 1px solid rgba(255, 194, 92, 0.48) !important;
  border-radius: 7px !important;
  box-shadow: 0 0 24px rgba(255, 122, 0, 0.12) !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
}

.sty .sty-one-pattern .span1 {
  color: #aeb7ca !important;
  background: #282b3a !important;
  border-color: rgba(111, 121, 151, 0.32) !important;
  box-shadow: none !important;
}

.sty .sty-two {
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
}

.sty .sty-two-list {
  min-height: 0 !important;
  max-height: none !important;
  flex: 1 1 auto !important;
  overflow-y: auto !important;
  padding-right: 6px !important;
}

.sty .sty-two-list ul {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 12px !important;
}

.sty .sty-two-list ul li {
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
}

.sty .twolist-warp {
  height: 156px !important;
  position: relative !important;
  overflow: hidden !important;
  border: 1px solid rgba(111, 121, 151, 0.24) !important;
  border-radius: 10px !important;
  background:
    radial-gradient(circle at 50% 36%, rgba(135, 77, 255, 0.22), transparent 58%),
    linear-gradient(180deg, #292c3b, #222534) !important;
  transition: border-color 0.16s ease, transform 0.16s ease, box-shadow 0.16s ease !important;
}

.sty .twolist-warp:hover {
  transform: translateY(-2px) !important;
  border-color: rgba(255, 122, 0, 0.7) !important;
  box-shadow: 0 18px 30px rgba(0, 0, 0, 0.22), 0 0 24px rgba(255, 122, 0, 0.12) !important;
}

.sty .twolist-top {
  height: 104px !important;
  display: grid !important;
  place-items: center !important;
}

.sty .twolist-top img {
  width: 132px !important;
  height: 104px !important;
  object-fit: contain !important;
  filter: drop-shadow(0 16px 18px rgba(0, 0, 0, 0.42)) !important;
}

.sty .twolist-bot,
.sty .threelist-name {
  height: 36px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 5px !important;
  color: #ffc34d !important;
  font-size: 15px !important;
  line-height: 18px !important;
  font-weight: 1000 !important;
}

.sty .twolist-bot img,
.sty .threelist-name img {
  width: 13px !important;
  height: 13px !important;
  content: url("../assets/pizzaking/pizza-token.svg") !important;
}

.sty .twolist-num {
  min-width: 38px !important;
  height: 24px !important;
  padding: 0 8px !important;
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #10121c !important;
  background: #ffc34d !important;
  border-radius: 999px !important;
  font-size: 13px !important;
  font-weight: 1000 !important;
}

.sty .twolist-num1 {
  display: none !important;
}

.sty .sty-three {
  position: sticky !important;
  bottom: 0 !important;
}

.sty .sty-three-hint {
  height: 34px !important;
  margin: 0 0 12px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  color: #aeb7ca !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

.sty .sty-three-hint span {
  color: transparent !important;
  font-size: 0 !important;
}

.sty .sty-three-hint span:first-child {
  color: #aeb7ca !important;
  font-size: 13px !important;
}

.sty .sty-three-hint span:nth-child(2)::before {
  content: "价值 " !important;
  color: #aeb7ca !important;
  font-size: 13px !important;
}

.sty .sty-three-hint strong {
  color: #ffc34d !important;
  font-size: 20px !important;
  font-weight: 1000 !important;
}

.sty .sty-three-list ul {
  display: grid !important;
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  gap: 8px !important;
}

.sty .sty-three-list ul li {
  width: auto !important;
  height: 92px !important;
  margin: 0 !important;
}

.sty .threelist-warp {
  height: 92px !important;
  border: 1px dashed rgba(111, 121, 151, 0.32) !important;
  border-radius: 9px !important;
  background: rgba(26, 28, 40, 0.72) !important;
}

.sty .threelist-img {
  height: 58px !important;
  display: grid !important;
  place-items: center !important;
}

.sty .threelist-img img {
  width: 78px !important;
  height: 58px !important;
  object-fit: contain !important;
}

.sty .sty-three-btn1 {
  margin-top: 14px !important;
}

.sty .sty-three-btn {
  width: 100% !important;
  height: 50px !important;
  color: #fff7df !important;
  background: linear-gradient(180deg, #ff9a19, #f26900) !important;
  border: 0 !important;
  border-radius: 7px !important;
  box-shadow: 0 16px 30px rgba(242, 105, 0, 0.28) !important;
  font-size: 0 !important;
  font-weight: 1000 !important;
}

.sty .sty-three-btn::after {
  content: "创建战斗" !important;
  font-size: 16px !important;
}

@media screen and (max-width: 760px) {
  .sty .el-drawer.rtl {
    width: 100vw !important;
  }

  .sty .sty-warp {
    padding: 18px 14px !important;
  }

  .sty .sty-two-list ul {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 battle list parity pass: desktop density and HotPizza-like room cards. */
body:has(.pk-lucky-page) .pk-lucky-page .pk-lucky-content {
  min-height: calc(100vh - 202px) !important;
  background:
    radial-gradient(circle at 52% 58px, rgba(97, 62, 163, 0.16), transparent 36%),
    linear-gradient(180deg, #1f2230 0%, #1b1e2a 100%) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp {
  width: 100% !important;
  max-width: min(1580px, calc(100vw - 276px)) !important;
  margin: 0 auto !important;
  padding: 26px 20px 104px !important;
  box-sizing: border-box !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top {
  height: 58px !important;
  margin: 0 0 14px !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  border: 0 !important;
  background: transparent !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .left {
  color: #f5f6fb !important;
  font-size: 24px !important;
  line-height: 1 !important;
  font-weight: 1000 !important;
  letter-spacing: 0 !important;
  text-shadow: 0 2px 18px rgba(255, 255, 255, 0.12) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .left::before {
  content: "" !important;
  width: 19px !important;
  height: 19px !important;
  margin-right: 10px !important;
  display: inline-block !important;
  vertical-align: -3px !important;
  border: 3px solid #7d6cff !important;
  border-radius: 50% !important;
  box-shadow: 0 0 18px rgba(125, 108, 255, 0.5) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .right {
  gap: 8px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span,
body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort {
  height: 40px !important;
  border-radius: 7px !important;
  background: #272a38 !important;
  border: 1px solid rgba(88, 98, 126, 0.72) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span1 {
  color: #cbd2e3 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span2 {
  min-width: 134px !important;
  color: #fff !important;
  background: linear-gradient(180deg, #ff9418, #ff7300) !important;
  border-color: rgba(255, 181, 86, 0.58) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.18),
    0 14px 28px rgba(255, 114, 0, 0.2) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort {
  padding: 0 14px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .luc-list,
body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-preview-cases {
  height: 156px !important;
  margin: 0 0 16px !important;
  padding: 0 !important;
  border: 1px solid rgba(63, 70, 94, 0.56) !important;
  border-radius: 0 !important;
  background: #1c1f2b !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .luc-list ul {
  height: 156px !important;
  display: flex !important;
  align-items: stretch !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .luc-list ul li {
  width: 154px !important;
  height: 156px !important;
  flex: 0 0 154px !important;
  border-right: 1px solid rgba(63, 70, 94, 0.56) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .luc-list .list-warp {
  height: 156px !important;
  margin: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background:
    radial-gradient(circle at 50% 35%, rgba(103, 58, 208, 0.35), transparent 50%),
    #1d202c !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .luc-list .list-img {
  height: 106px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .luc-list .list-img img {
  width: 118px !important;
  height: 98px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .hint {
  height: 54px !important;
  margin: 0 0 18px !important;
  padding: 0 18px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  color: #8e97aa !important;
  background: rgba(31, 34, 47, 0.9) !important;
  border: 1px solid rgba(63, 70, 94, 0.46) !important;
  border-radius: 8px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .hint span:last-child {
  color: #ffd36b !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .ranking {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room {
  margin: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
  width: 100% !important;
  margin: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
  width: 100% !important;
  margin: 0 !important;
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 24px 14px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  height: 235px !important;
  min-width: 0 !important;
  border-radius: 8px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  height: 235px !important;
  border: 1px solid rgba(71, 79, 105, 0.82) !important;
  border-bottom-color: #ff6f00 !important;
  border-radius: 9px !important;
  background:
    linear-gradient(90deg, rgba(42, 45, 60, 0.98) 0%, rgba(42, 45, 60, 0.98) 61%, rgba(31, 34, 47, 0.99) 61%, rgba(31, 34, 47, 0.99) 100%) !important;
  box-shadow:
    inset 0 -1px 0 rgba(255, 111, 0, 0.85),
    inset 0 1px 0 rgba(255, 255, 255, 0.03),
    0 20px 42px rgba(0, 0, 0, 0.24) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp:hover {
  border-color: rgba(255, 123, 12, 0.9) !important;
  transform: translateY(-2px) !important;
  box-shadow:
    inset 0 -1px 0 rgba(255, 111, 0, 0.92),
    inset 0 1px 0 rgba(255, 255, 255, 0.035),
    0 22px 48px rgba(0, 0, 0, 0.3),
    0 0 34px rgba(255, 123, 12, 0.14) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .three {
  width: 61% !important;
  height: 235px !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  background: linear-gradient(180deg, rgba(42, 45, 60, 0.98), rgba(36, 39, 53, 0.98)) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail {
  height: 235px !important;
  background:
    radial-gradient(circle at 50% 46%, rgba(244, 72, 98, 0.2), transparent 43%),
    linear-gradient(180deg, rgba(48, 51, 66, 0.96), rgba(40, 43, 58, 0.98)) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail::before {
  content: "" !important;
  position: absolute !important;
  inset: 0 !important;
  background:
    radial-gradient(circle at 50% 48%, rgba(255, 96, 64, 0.2), transparent 36%),
    linear-gradient(90deg, rgba(255, 122, 0, 0.1), transparent 42%) !important;
  opacity: 0.75 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail img {
  width: 112% !important;
  height: 186px !important;
  max-width: none !important;
  object-fit: contain !important;
  transform: translateY(8px) scale(1.08) !important;
  filter:
    drop-shadow(0 20px 22px rgba(0, 0, 0, 0.44))
    drop-shadow(0 0 22px rgba(255, 90, 63, 0.18)) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail .box-num {
  left: 17px !important;
  top: 18px !important;
  color: #aeb7c9 !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .two {
  left: 61% !important;
  width: 39% !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
  left: calc(61% + 24px) !important;
  top: 35px !important;
  height: 26px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top span {
  color: #ffc34d !important;
  font-size: 20px !important;
  line-height: 26px !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv {
  right: 22px !important;
  top: 35px !important;
  text-align: right !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-label {
  display: block !important;
  color: #a7afc1 !important;
  font-size: 13px !important;
  line-height: 16px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-value,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-count {
  color: #f5f7ff !important;
  font-size: 19px !important;
  line-height: 24px !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv > [class^="text_"] {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
  left: calc(61% + 24px) !important;
  top: 105px !important;
  color: #21e2f6 !important;
  font-size: 17px !important;
  font-weight: 1000 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
  position: absolute !important;
  left: calc(61% + 24px) !important;
  top: 126px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  gap: 7px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo .pk-warp {
  margin: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-tou {
  width: 32px !important;
  height: 32px !important;
  border: 1px solid rgba(114, 125, 155, 0.74) !important;
  border-radius: 50% !important;
  background: #222635 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-tou img,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-true {
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-false {
  width: 16px !important;
  height: 16px !important;
  margin: 8px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  right: 24px !important;
  bottom: 22px !important;
  min-width: 132px !important;
  height: 40px !important;
  color: #f6f1df !important;
  border-color: rgba(255, 229, 184, 0.76) !important;
  background: rgba(40, 43, 57, 0.78) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .more-btn {
  height: 74px !important;
  display: grid !important;
  place-items: center !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .more-btn span {
  height: 42px !important;
  min-width: 150px !important;
  padding: 0 24px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #cfd7e8 !important;
  background: #272a38 !important;
  border: 1px solid rgba(89, 98, 126, 0.72) !important;
  border-radius: 7px !important;
  font-weight: 900 !important;
}

@media screen and (max-width: 1380px) {
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media screen and (max-width: 980px) {
  body:has(.pk-lucky-page) .index-shell-page .bot-right {
    width: 100% !important;
    margin-left: 0 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp {
    max-width: calc(100vw - 28px) !important;
    padding: 18px 0 74px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top {
    height: auto !important;
    align-items: flex-start !important;
    flex-direction: column !important;
    gap: 14px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    grid-template-columns: 1fr !important;
  }
}
</style>

<style lang="less">
.pk-lucky-page .pk-lucky-content {
  min-height: calc(100vh - 198px) !important;
}

.pk-lucky-page .lucky-warp {
  max-width: 1540px !important;
  padding: 30px 28px 96px !important;
}

.pk-lucky-page .luc-list,
.pk-lucky-page .pk-battle-preview-cases,
.pk-lucky-page .hint {
  border-color: rgba(111, 121, 151, 0.22) !important;
  box-shadow: inset 0 1px 0 rgba(255, 224, 170, 0.04) !important;
}

.pk-lucky-page .room .room-box .room-box-ul {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 22px !important;
}

.pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  height: 226px !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  height: 226px !important;
  border-color: rgba(80, 88, 113, 0.94) !important;
  border-bottom-color: rgba(255, 108, 22, 0.94) !important;
  background:
    linear-gradient(90deg, rgba(39, 42, 57, 0.98) 0%, rgba(39, 42, 57, 0.98) 60%, rgba(31, 33, 47, 0.98) 60%, rgba(29, 31, 44, 0.98) 100%) !important;
  box-shadow:
    inset 0 -1px 0 rgba(255, 108, 22, 0.7),
    inset 0 1px 0 rgba(255, 255, 255, 0.035),
    0 18px 38px rgba(0, 0, 0, 0.22) !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp:hover {
  border-color: rgba(255, 122, 0, 0.72) !important;
  box-shadow:
    inset 0 -1px 0 rgba(255, 108, 22, 0.78),
    inset 0 1px 0 rgba(255, 255, 255, 0.035),
    0 22px 46px rgba(0, 0, 0, 0.26),
    0 0 30px rgba(255, 122, 0, 0.14) !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::before {
  left: 14px !important;
  top: 14px !important;
}

.pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  right: 42px !important;
  bottom: 24px !important;
  min-width: 156px !important;
  height: 42px !important;
  background: rgba(34, 37, 52, 0.78) !important;
  border-color: rgba(120, 130, 160, 0.78) !important;
  color: #f6f7fb !important;
  font-size: 14px !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .three {
  width: 60% !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  background:
    linear-gradient(180deg, rgba(41, 44, 59, 0.98), rgba(35, 37, 51, 0.98)) !important;
}

.pk-lucky-page .room .roombox-warp .box-detail {
  height: 226px !important;
}

.pk-lucky-page .room .roombox-warp .box-detail img {
  width: 92% !important;
  height: 176px !important;
}

.pk-lucky-page .room .roombox-warp .box-detail .box-num {
  left: 20px !important;
  top: 18px !important;
  font-size: 15px !important;
}

.pk-lucky-page .room .roombox-warp .two {
  left: 60% !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top {
  left: calc(60% + 30px) !important;
  top: 35px !important;
}

.pk-lucky-page .room .roombox-warp .card-footer .two-top span {
  font-size: 20px !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv {
  right: 30px !important;
  top: 35px !important;
}

.pk-lucky-page .room .roombox-warp .status-condiv::before,
.pk-lucky-page .room .roombox-warp .pk-player-count {
  font-size: 18px !important;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count {
  left: calc(60% + 30px) !important;
  top: 102px !important;
  font-size: 16px !important;
}

.pk-lucky-page .room .roombox-warp .pk-rounds-count::before {
  width: 36px !important;
}

.pk-lucky-page .room .roombox-warp .room-peo {
  margin-top: 48px !important;
}

.pk-lucky-page .room .roombox-warp .pk-tou {
  width: 28px !important;
  height: 28px !important;
}

.pk-lucky-page .room .roombox-warp .pk-true {
  width: 28px !important;
  height: 28px !important;
}

.pk-lucky-page .room .roombox-warp .pk-false {
  width: 15px !important;
  height: 15px !important;
}

@media screen and (max-width: 1180px) {
  .pk-lucky-page .lucky-warp {
    padding: 20px 14px 72px !important;
  }

  .pk-lucky-page .room .room-box .room-box-ul {
    grid-template-columns: 1fr !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 battle list spacing fix: keep price/player/rounds from colliding. */
body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 24px 14px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
  left: calc(61% + 24px) !important;
  top: 30px !important;
  width: auto !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv {
  left: calc(61% + 24px) !important;
  right: 22px !important;
  top: 68px !important;
  width: auto !important;
  text-align: left !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-label {
  display: inline-block !important;
  margin-right: 6px !important;
  vertical-align: baseline !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-value,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-count {
  display: inline-block !important;
  font-size: 18px !important;
  line-height: 24px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
  left: calc(61% + 24px) !important;
  top: 106px !important;
  width: calc(39% - 48px) !important;
  white-space: nowrap !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
  left: calc(61% + 24px) !important;
  top: 136px !important;
  max-width: calc(39% - 48px) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  right: 22px !important;
  bottom: 18px !important;
  min-width: 132px !important;
}

@media screen and (max-width: 1380px) {
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media screen and (max-width: 980px) {
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    grid-template-columns: 1fr !important;
  }
}

/* 2026-07-05 exact-pass: battle short cards text direction, watch button and glow. */
body:has(.pk-lucky-page) .pk-lucky-page {
  background:
    radial-gradient(ellipse at 54% 220px, rgba(236, 216, 184, 0.055), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 420px, #171923 100%) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-lucky-content,
body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp {
  max-width: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top {
  height: 72px !important;
  margin: 0 !important;
  padding: 0 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  background: #20222f !important;
  border-bottom: 1px solid #2b2d3c !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .left {
  color: #f4ead8 !important;
  font-size: 24px !important;
  line-height: 72px !important;
  font-weight: 900 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .left::before {
  content: "箱子战斗" !important;
  color: #f4ead8 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .top .left {
  font-size: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .right-span,
body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort span {
  color: #aab3c4 !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .right-span2 {
  min-width: 132px !important;
  height: 42px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #fff7df !important;
  border: 1px solid rgba(255, 138, 31, 0.5) !important;
  border-radius: 6px !important;
  background: linear-gradient(180deg, #ff971f, #f26b00) !important;
  box-shadow: 0 12px 24px rgba(242, 105, 0, 0.2) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title span {
  font-size: 0 !important;
  writing-mode: vertical-rl !important;
  text-orientation: upright !important;
  transform: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title span::before {
  content: "创建战斗" !important;
  color: #ecd8b8 !important;
  font-size: 18px !important;
  line-height: 1.18 !important;
  font-weight: 900 !important;
  letter-spacing: 1px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room {
  margin-top: 0 !important;
  background: #1c1d29 !important;
  border-bottom: 1px solid #2b2d3c !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
  padding-left: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  content: "观看" !important;
  top: 18px !important;
  left: 50% !important;
  right: auto !important;
  width: 126px !important;
  min-width: 126px !important;
  height: 34px !important;
  padding: 0 !important;
  color: #ecd8b8 !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 6px !important;
  transform: translateX(-50%) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::before {
  content: "" !important;
  display: block !important;
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  height: 2px !important;
  background: linear-gradient(90deg, #ff6f00, rgba(255, 111, 0, 0.22), transparent) !important;
  box-shadow: 0 0 18px rgba(255, 111, 0, 0.35) !important;
  z-index: 9 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .one {
  background:
    radial-gradient(ellipse at 50% 0, rgba(236, 216, 184, 0.11), transparent 70%),
    linear-gradient(180deg, #222430, #2a2c38) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail {
  border-bottom-color: rgba(236, 216, 184, 0.5) !important;
  background:
    linear-gradient(180deg, rgba(40, 42, 53, 0), rgba(236, 216, 184, 0.18)),
    #282a35 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail img {
  filter:
    drop-shadow(0 15px 18px rgba(0, 0, 0, 0.46))
    drop-shadow(0 0 18px rgba(255, 122, 0, 0.18)) !important;
}
</style>

<style lang="less">
/* 2026-07-03 create battle drawer final overrides. */
.el-drawer__wrapper.sty .el-drawer.rtl {
  width: 620px !important;
  max-width: 100vw !important;
  left: auto !important;
  right: 0 !important;
  background:
    radial-gradient(circle at 80% 0, rgba(255, 156, 31, 0.16), transparent 38%),
    linear-gradient(180deg, #242736 0%, #1b1d29 100%) !important;
  border-left: 1px solid rgba(111, 121, 151, 0.28) !important;
  box-shadow: -28px 0 70px rgba(0, 0, 0, 0.48) !important;
}

.el-drawer__wrapper.sty .el-drawer__body {
  height: 100% !important;
  padding: 0 !important;
  overflow: hidden !important;
}

.el-drawer__wrapper.sty .sty-warp {
  width: auto !important;
  height: 100% !important;
  padding: 24px !important;
  display: grid !important;
  grid-template-rows: auto minmax(0, 1fr) auto !important;
  gap: 18px !important;
}

.el-drawer__wrapper.sty .sty-warp::before {
  content: "创建战斗" !important;
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
  color: #f7efe0 !important;
  font-size: 28px !important;
  font-weight: 1000 !important;
}

.el-drawer__wrapper.sty .sty-one-hint,
.el-drawer__wrapper.sty .sty-two-hint1,
.el-drawer__wrapper.sty .sty-two-hint2 {
  color: transparent !important;
  font-size: 0 !important;
}

.el-drawer__wrapper.sty .sty-one-hint::after {
  content: "选择玩家模式" !important;
  color: #f5f7ff !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
}

.el-drawer__wrapper.sty .sty-two-hint1::after {
  content: "选择盲盒" !important;
  color: #f5f7ff !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
}

.el-drawer__wrapper.sty .sty-two-hint2::after {
  content: "最多选择 6 个盲盒，点击箱子添加，再点击下方已选箱子移除" !important;
  color: #8f98ab !important;
  font-size: 12px !important;
  line-height: 18px !important;
  font-weight: 800 !important;
}

.el-drawer__wrapper.sty .sty-two {
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
}

.el-drawer__wrapper.sty .sty-two-list {
  min-height: 0 !important;
  flex: 1 1 auto !important;
  overflow-y: auto !important;
}

.el-drawer__wrapper.sty .sty-two-list ul {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 12px !important;
}

.el-drawer__wrapper.sty .sty-two-list ul li {
  width: auto !important;
  margin: 0 !important;
}

.el-drawer__wrapper.sty .twolist-warp {
  height: 156px !important;
}

.el-drawer__wrapper.sty .sty-three-hint {
  color: #aeb7ca !important;
}

.el-drawer__wrapper.sty .sty-three-hint span {
  color: transparent !important;
  font-size: 0 !important;
}

.el-drawer__wrapper.sty .sty-three-hint span:first-child::before {
  content: "已选择：" !important;
  color: #aeb7ca !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

.el-drawer__wrapper.sty .sty-three-hint span:first-child::after {
  content: "/6" !important;
  color: #aeb7ca !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

.el-drawer__wrapper.sty .sty-three-hint span:nth-child(2)::before {
  content: "价值：" !important;
  color: #aeb7ca !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

.el-drawer__wrapper.sty .sty-three-hint strong {
  color: #ffc34d !important;
  font-size: 20px !important;
  font-weight: 1000 !important;
}

.el-drawer__wrapper.sty .sty-three-btn {
  color: transparent !important;
  font-size: 0 !important;
}

.el-drawer__wrapper.sty .sty-three-btn::after {
  content: "创建战斗" !important;
  color: #fff7df !important;
  font-size: 16px !important;
}

@media screen and (max-width: 760px) {
  .el-drawer__wrapper.sty .el-drawer.rtl {
    width: 100vw !important;
  }

  .el-drawer__wrapper.sty .sty-two-list ul {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 battle list final target metrics: keep HotPizza pvp-short scale after legacy overrides. */
.el-drawer__wrapper.sty .el-drawer.rtl {
  width: 760px !important;
  max-width: 100vw !important;
  background:
    radial-gradient(circle at 85% 0, rgba(237, 177, 69, 0.16), transparent 34%),
    linear-gradient(180deg, #242631 0%, #1c1d29 100%) !important;
  border-left: 1px solid rgba(236, 216, 184, 0.18) !important;
  box-shadow: -34px 0 90px rgba(0, 0, 0, 0.56) !important;
}

.el-drawer__wrapper.sty .sty-warp {
  padding: 28px 30px !important;
  gap: 20px !important;
  background: transparent !important;
}

.el-drawer__wrapper.sty .sty-warp::before {
  content: "创建战斗" !important;
  height: 44px !important;
  color: #f5f5f5 !important;
  font-size: 30px !important;
  line-height: 100% !important;
  font-weight: 800 !important;
  letter-spacing: -0.4px !important;
}

.el-drawer__wrapper.sty .sty-one,
.el-drawer__wrapper.sty .sty-two,
.el-drawer__wrapper.sty .sty-three {
  padding: 16px !important;
  border: 1px solid rgba(236, 216, 184, 0.12) !important;
  border-radius: 12px !important;
  background: rgba(35, 37, 49, 0.74) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
}

.el-drawer__wrapper.sty .sty-one-pattern {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 10px !important;
}

.el-drawer__wrapper.sty .sty-one-pattern span {
  width: auto !important;
  height: 42px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 8px !important;
  background: rgba(236, 216, 184, 0.1) !important;
  color: #ecd8b8 !important;
  font-size: 14px !important;
  font-weight: 800 !important;
}

.el-drawer__wrapper.sty .sty-one-pattern span.span1 {
  border-color: rgba(236, 216, 184, 0.12) !important;
  background: #1f212d !important;
  color: rgba(240, 248, 255, 0.72) !important;
}

.el-drawer__wrapper.sty .sty-two-list {
  margin-top: 12px !important;
}

.el-drawer__wrapper.sty .sty-two-list ul {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  gap: 10px !important;
}

.el-drawer__wrapper.sty .twolist-warp {
  height: 132px !important;
  border: 1px solid rgba(236, 216, 184, 0.1) !important;
  border-radius: 10px !important;
  background: linear-gradient(180deg, rgba(40, 42, 53, 0), rgba(236, 216, 184, 0.08)), #282a35 !important;
  overflow: hidden !important;
}

.el-drawer__wrapper.sty .twolist-top {
  height: 88px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.el-drawer__wrapper.sty .twolist-top img {
  max-width: 92% !important;
  max-height: 78px !important;
  object-fit: contain !important;
}

.el-drawer__wrapper.sty .twolist-bot {
  height: 34px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  color: #edb145 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
}

.el-drawer__wrapper.sty .twolist-bot img {
  width: 13px !important;
  height: 13px !important;
}

.el-drawer__wrapper.sty .twolist-num,
.el-drawer__wrapper.sty .twolist-num1 {
  right: 8px !important;
  top: 8px !important;
  min-width: 24px !important;
  height: 20px !important;
  border-radius: 10px !important;
  background: rgba(237, 177, 69, 0.16) !important;
  color: #ecd8b8 !important;
  font-size: 12px !important;
  line-height: 20px !important;
}

.el-drawer__wrapper.sty .sty-three-list ul {
  display: grid !important;
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  gap: 8px !important;
}

.el-drawer__wrapper.sty .sty-three-list ul li {
  width: auto !important;
  margin: 0 !important;
}

.el-drawer__wrapper.sty .threelist-warp {
  height: 78px !important;
  border: 1px dashed rgba(236, 216, 184, 0.22) !important;
  border-radius: 8px !important;
  background: #1f212d !important;
}

.el-drawer__wrapper.sty .threelist-img img {
  max-height: 48px !important;
  object-fit: contain !important;
}

.el-drawer__wrapper.sty .sty-three-btn1 {
  margin-top: 14px !important;
}

.el-drawer__wrapper.sty .sty-three-btn {
  width: 100% !important;
  height: 46px !important;
  border: 0 !important;
  border-radius: 8px !important;
  background: linear-gradient(180deg, #ff9d00 0%, #ff6f00 100%) !important;
  box-shadow: 0 0 22px rgba(255, 122, 0, 0.28) !important;
  color: transparent !important;
  font-size: 0 !important;
  font-weight: 900 !important;
}

.el-drawer__wrapper.sty .sty-three-btn::after {
  content: "创建战斗" !important;
  color: #fff7df !important;
  font-size: 16px !important;
  line-height: 46px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  height: 157px !important;
  margin: 28px 0 0 !important;
  padding: 0 !important;
  background: #1c1d29 !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room::after {
  content: "" !important;
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
  z-index: 12 !important;
  width: 200px !important;
  height: 157px !important;
  pointer-events: none !important;
  background: linear-gradient(270deg, #1c1d29, rgba(28, 29, 41, 0)) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room > .clear {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title {
  width: 92px !important;
  height: 157px !important;
  flex: 0 0 92px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #1c1d29 !important;
  z-index: 13 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title span {
  margin-top: 10px !important;
  color: #ecd8b8 !important;
  font-size: 16px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
  writing-mode: vertical-rl !important;
  transform: rotate(180deg) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
  min-width: 0 !important;
  width: auto !important;
  flex: 1 1 auto !important;
  margin: 0 !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
  width: max-content !important;
  display: flex !important;
  align-items: center !important;
  grid-template-columns: none !important;
  gap: 10px !important;
  overflow: visible !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
  width: 394px !important;
  min-width: 394px !important;
  max-width: 394px !important;
  flex: 0 0 394px !important;
  height: 137px !important;
  margin: 0 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
  height: 137px !important;
  border: 0 !important;
  border-radius: 10px !important;
  background: transparent !important;
  box-shadow: none !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::before {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .one {
  height: 66px !important;
  border-radius: 10px 10px 0 0 !important;
  background:
    radial-gradient(100% 50% at 50% 0, rgba(236, 216, 184, 0.1) 0, rgba(39, 42, 54, 0) 100%),
    linear-gradient(180deg, #21232f, #282a35) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .three {
  top: 66px !important;
  width: 100% !important;
  height: 70px !important;
  display: grid !important;
  grid-template-columns: repeat(4, minmax(78px, 1fr)) !important;
  border-radius: 0 0 10px 10px !important;
  overflow: hidden !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail {
  height: 70px !important;
  border-bottom: 1px solid #ecd8b8 !important;
  background: linear-gradient(180deg, rgba(40, 42, 53, 0), rgba(236, 216, 184, 0.2)), #282a35 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail img {
  height: 58px !important;
  width: auto !important;
  max-width: 92% !important;
  margin: 8px auto 0 !important;
  display: block !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail .box-num {
  left: 5px !important;
  top: 5px !important;
  color: #ecd8b8 !important;
  font-size: 10px !important;
  line-height: 100% !important;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  left: auto !important;
  right: 20px !important;
  top: 14px !important;
  width: auto !important;
  height: 18px !important;
  font-size: 14px !important;
  z-index: 8 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top::before {
  content: "" !important;
  width: 4px !important;
  height: 4px !important;
  margin-right: 6px !important;
  border-radius: 4px !important;
  background: #fd6b01 !important;
  box-shadow: 0 0 6px #fd6b01 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .card-footer .two-top::before {
  background: #01fd05 !important;
  box-shadow: 0 0 6px #01fd05 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top span {
  color: #edb145 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  font-weight: 700 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top img {
  width: 14px !important;
  height: 14px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv {
  left: 20px !important;
  top: 14px !important;
  right: auto !important;
  width: auto !important;
  height: 38px !important;
  text-align: left !important;
  color: rgba(240, 248, 255, 0.8) !important;
  font-size: 12px !important;
  line-height: 100% !important;
  z-index: 8 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv .point,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv > .pk-player-count,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv > [class^="text_"],
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-img,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .span3 {
  display: none !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-label,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-value,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-count {
  display: inline-block !important;
  color: rgba(240, 248, 255, 0.8) !important;
  font-size: 12px !important;
  line-height: 100% !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
  right: 20px !important;
  left: auto !important;
  top: 38px !important;
  width: auto !important;
  color: rgba(240, 248, 255, 0.8) !important;
  font-size: 12px !important;
  line-height: 100% !important;
  text-align: right !important;
  white-space: nowrap !important;
  z-index: 8 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
  left: 20px !important;
  top: 36px !important;
  max-width: 154px !important;
  height: 22px !important;
  gap: 3px !important;
  z-index: 9 !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-tou,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-tou img,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-true,
body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-false {
  width: 16px !important;
  height: 16px !important;
  border-radius: 16px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .vs {
  width: 20px !important;
  height: 20px !important;
}

body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
  content: "观看  ○" !important;
  top: 18px !important;
  right: 50% !important;
  bottom: auto !important;
  transform: translateX(50%) !important;
  min-width: 92px !important;
  width: auto !important;
  height: 32px !important;
  padding: 0 18px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 6px !important;
  background: transparent !important;
  color: #ecd8b8 !important;
  font-size: 14px !important;
  line-height: 32px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  text-transform: uppercase !important;
  box-shadow: none !important;
}

@media screen and (max-width: 980px) {
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    grid-template-columns: 1fr !important;
  }
}

/* 2026-07-20 battle desktop final pass: prevent legacy blocks from compressing the title or repainting status buttons. */
@media screen and (min-width: 981px) {
  body:has(.pk-lucky-page) .pk-lucky-page .top {
    min-width: 0 !important;
    flex-wrap: nowrap !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .left {
    width: 176px !important;
    min-width: 176px !important;
    flex: 0 0 176px !important;
    height: 72px !important;
    overflow: visible !important;
    white-space: nowrap !important;
    word-break: keep-all !important;
    writing-mode: horizontal-tb !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .left::before {
    display: block !important;
    width: auto !important;
    white-space: nowrap !important;
    writing-mode: horizontal-tb !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .right {
    min-width: 0 !important;
    flex: 1 1 auto !important;
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    justify-content: flex-end !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title span {
    margin-top: 0 !important;
    font-size: 0 !important;
    writing-mode: vertical-rl !important;
    text-orientation: upright !important;
    transform: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title span::before {
    content: "创建战斗" !important;
    display: block !important;
    color: #ecd8b8 !important;
    font-size: 18px !important;
    font-weight: 900 !important;
    line-height: 1.2 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    height: 137px !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li {
    height: 137px !important;
    min-height: 137px !important;
    max-height: 137px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_1 .roombox-warp::after,
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_2 .roombox-warp::after,
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li.bg_3 .roombox-warp::after {
    content: "观看  ○" !important;
    position: absolute !important;
    z-index: 30 !important;
    top: 18px !important;
    right: 50% !important;
    bottom: auto !important;
    min-width: 92px !important;
    padding: 0 18px !important;
    transform: translateX(50%) !important;
    border: 1px solid #ecd8b8 !important;
    background: transparent !important;
    color: #ecd8b8 !important;
    box-shadow: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
    position: relative !important;
  }

  /* The standalone battle grid must not inherit the home carousel fade. */
  body:has(.pk-lucky-page) .pk-lucky-page .room::after {
    display: none !important;
  }
}

/* The battle route is a room grid, not the compact PVP strip reused on the home page. */
@media screen and (min-width: 981px) {
  body:has(.pk-lucky-page) .pk-lucky-page .room {
    height: auto !important;
    min-height: 0 !important;
    display: block !important;
    margin: 26px 0 0 !important;
    background: transparent !important;
    overflow: visible !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title {
    display: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
    width: 100% !important;
    overflow: visible !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    width: 100% !important;
    height: auto !important;
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 20px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li,
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
    width: 100% !important;
    min-width: 0 !important;
    max-width: none !important;
    height: 170px !important;
    min-height: 170px !important;
    max-height: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
    border: 1px solid rgba(68, 74, 98, 0.9) !important;
    border-bottom-color: rgba(68, 74, 98, 0.9) !important;
    border-radius: 10px !important;
    background: linear-gradient(90deg, #202331 0 65%, #1f2230 65% 100%) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .three {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 65% !important;
    height: 170px !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    overflow: hidden !important;
  }

  /* Keep the case stage independent from the legacy stacked card flow. */
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer {
    position: absolute !important;
    inset: 0 !important;
    width: 100% !important;
    height: 170px !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail {
    height: 170px !important;
    position: relative !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail img {
    height: 138px !important;
    position: absolute !important;
    left: 50% !important;
    top: 50% !important;
    margin: 0 !important;
    transform: translate(-50%, -50%) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .two {
    left: 65% !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv {
    left: calc(65% + 26px) !important;
    right: 22px !important;
    top: 22px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
    left: calc(65% + 26px) !important;
    top: 25px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
    left: calc(65% + 26px) !important;
    top: 76px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
    right: 26px !important;
    top: 70px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
    right: 24px !important;
    bottom: 20px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail::before {
    opacity: 0.38 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail::after {
    display: none !important;
  }
}

/* The battle route needs full cards on small screens, not the home-page PVP strip. */
@media screen and (max-width: 980px) {
  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp {
    width: 100% !important;
    max-width: 100% !important;
    padding: 12px 10px 68px !important;
    box-sizing: border-box !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top {
    height: auto !important;
    min-height: 0 !important;
    padding: 12px 4px !important;
    display: block !important;
    background: transparent !important;
    border: 0 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .left {
    width: auto !important;
    min-width: 0 !important;
    height: auto !important;
    margin-bottom: 10px !important;
    color: #f4ead8 !important;
    font-size: 0 !important;
    line-height: 1 !important;
    writing-mode: horizontal-tb !important;
    transform: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .left::before {
    content: "箱子战斗" !important;
    width: auto !important;
    height: auto !important;
    margin: 0 !important;
    display: block !important;
    color: #f4ead8 !important;
    font-size: 22px !important;
    line-height: 1.2 !important;
    font-weight: 900 !important;
    writing-mode: horizontal-tb !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .left::after {
    display: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .right {
    width: 100% !important;
    min-width: 0 !important;
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    justify-content: flex-start !important;
    gap: 8px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span,
  body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span1,
  body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span2,
  body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort span {
    min-width: 0 !important;
    height: 32px !important;
    margin: 0 !important;
    padding: 0 10px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 12px !important;
    line-height: 32px !important;
    white-space: nowrap !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span2 {
    margin-left: auto !important;
    border-radius: 6px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort {
    order: 3 !important;
    width: 100% !important;
    display: flex !important;
    gap: 8px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room,
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
    display: block !important;
    width: 100% !important;
    height: auto !important;
    margin: 12px 0 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: transparent !important;
    border: 0 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room::after,
  body:has(.pk-lucky-page) .pk-lucky-page .pk-pvp-short-title {
    display: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    width: 100% !important;
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 12px !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li,
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
    width: 100% !important;
    min-width: 0 !important;
    max-width: none !important;
    height: 258px !important;
    min-height: 258px !important;
    max-height: 258px !important;
    margin: 0 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
    position: relative !important;
    border: 1px solid rgba(80, 88, 113, 0.94) !important;
    border-bottom-color: rgba(255, 108, 22, 0.94) !important;
    border-radius: 10px !important;
    background: linear-gradient(180deg, #242735 0 48%, #1f2230 48% 100%) !important;
    overflow: hidden !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .one {
    height: 0 !important;
    position: static !important;
    overflow: visible !important;
    background: transparent !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: 124px !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .three {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: 124px !important;
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    overflow: hidden !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail {
    height: 124px !important;
    border-bottom: 1px solid rgba(236, 216, 184, 0.26) !important;
    border-right-color: rgba(17, 19, 28, 0.72) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail img {
    width: auto !important;
    height: 102px !important;
    max-width: 92% !important;
    margin: 10px auto 0 !important;
    display: block !important;
    object-fit: contain !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail .box-num {
    left: 10px !important;
    top: 10px !important;
    font-size: 12px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .two {
    position: absolute !important;
    left: 0 !important;
    top: 124px !important;
    width: 100% !important;
    height: 134px !important;
    background: transparent !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv {
    left: 16px !important;
    right: auto !important;
    top: 16px !important;
    width: auto !important;
    font-size: 15px !important;
    text-align: left !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-label,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-value,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-player-count {
    font-size: 15px !important;
    line-height: 20px !important;
    writing-mode: horizontal-tb !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
    left: 16px !important;
    right: auto !important;
    top: 48px !important;
    width: auto !important;
    font-size: 13px !important;
    text-align: left !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
    left: 16px !important;
    right: auto !important;
    top: 78px !important;
    max-width: 150px !important;
    height: 24px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-tou,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-tou img,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-true,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-false {
    width: 22px !important;
    height: 22px !important;
    border-radius: 50% !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
    right: 16px !important;
    bottom: 16px !important;
    min-width: 92px !important;
    height: 34px !important;
    padding: 0 14px !important;
    transform: none !important;
    font-size: 13px !important;
    line-height: 34px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
    left: auto !important;
    right: 16px !important;
    top: 142px !important;
    bottom: auto !important;
    min-width: 0 !important;
    font-size: 16px !important;
  }
}

@media screen and (max-width: 600px) {
  body:has(.pk-lucky-page) .pk-lucky-page,
  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp {
    padding-bottom: 94px !important;
  }
}
</style>

<style lang="less">
/* 2026-07-25 desktop battle parity: final cascade after legacy battle style passes. */
@media screen and (min-width: 981px) {
  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp {
    padding: 16px 20px 88px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top {
    height: 66px !important;
    min-height: 66px !important;
    margin: 0 0 20px !important;
    padding: 0 14px !important;
    background: transparent !important;
    border-bottom: 1px solid rgba(86, 93, 118, 0.34) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .top .left {
    width: auto !important;
    min-width: 0 !important;
    flex: 0 0 auto !important;
    height: 66px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .top .left::before {
    content: "箱子战斗" !important;
    color: #f4ead8 !important;
    font-size: 20px !important;
    line-height: 66px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span1 {
    height: 34px !important;
    padding: 0 14px !important;
    line-height: 34px !important;
    background: #252836 !important;
    border-color: rgba(88, 98, 126, 0.6) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort {
    height: 34px !important;
    padding: 0 12px !important;
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .pk-battle-sort span {
    line-height: 34px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .top .right .right-span2 {
    min-width: 116px !important;
    height: 38px !important;
    line-height: 38px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .luc-list,
  body:has(.pk-lucky-page) .pk-lucky-page .hint {
    display: none !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room,
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box {
    margin: 0 !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 24px 20px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li,
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail {
    height: 171px !important;
    min-height: 171px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp {
    background: linear-gradient(90deg, #202331 0 65%, #1d202d 65% 100%) !important;
    border-color: rgba(64, 70, 92, 0.88) !important;
    border-bottom-color: rgba(242, 105, 0, 0.72) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .three {
    width: 65% !important;
    height: 171px !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail img {
    height: 134px !important;
    max-width: 92% !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .two {
    left: 65% !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv {
    left: calc(61% + 24px) !important;
    right: 20px !important;
    top: 30px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
    left: calc(61% + 24px) !important;
    right: auto !important;
    top: 32px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
    left: calc(61% + 24px) !important;
    top: 94px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
    right: 22px !important;
    top: 88px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
    top: auto !important;
    right: 22px !important;
    bottom: 24px !important;
    left: auto !important;
    min-width: 110px !important;
    height: 38px !important;
    line-height: 38px !important;
    transform: none !important;
  }
}
</style>

<style lang="less">
/* Final desktop battle stage: keep real room data while restoring the target-sized case artwork. */
@media screen and (min-width: 981px) {
  body:has(.pk-lucky-page) .pk-lucky-page .lucky-warp .room .room-box .room-box-ul > li,
  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer,
  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail {
    height: 210px !important;
    min-height: 210px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .three {
    width: 61% !important;
    height: 210px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .box-detail img {
    height: 174px !important;
    max-width: 98% !important;
    transform: translateY(4px) scale(1.06) !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .two {
    left: 61% !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .status-condiv {
    left: calc(61% + 24px) !important;
    top: 30px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .card-footer .two-top {
    left: calc(61% + 24px) !important;
    top: 32px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .pk-rounds-count {
    left: calc(61% + 24px) !important;
    top: 94px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .roombox-warp .room-peo {
    top: 88px !important;
  }

  body:has(.pk-lucky-page) .pk-lucky-page .room .room-box .room-box-ul > li .roombox-warp::after {
    bottom: 24px !important;
  }
}
</style>
